export default {
  // signin
  'sign.title': '로그인',
  'signIn.subtitle': '나야 매출처용 ERP 서비스',
  'country.korea': '대한민국',
  'country.vietnam': '베트남',
  'seller.businessNumber': '사업자번호',
  'sign.phone.message': '(-)없이 사업자번호를 입력해주세요',
  'staff.no': '직원번호',
  'error.BLANK_PHONE': '사업자번호를 입력해주세요',
  'error.BLANK_STAFF_ID': '직원번호를 입력해주세요',
  'error.BLANK_PASSWORD': '비밀번호를 입력해주세요',
  'error.INVALID_STAFF_ID': '존재하지 않는 직원 아이디입니다.',
  'error.INVALID_PHONE_NUMBER': '아이디가 존재하지 않습니다.',
  'error.INVALID_PASSWORD': '비밀번호가 일치하지 않습니다.',
  'error.INACTIVE_STAFF_ID': '사용 중지된 직원입니다.',
  'common.password': '비밀번호',
  'partner.password': '비밀번호',
  'sign.password.message': '비밀번호를 입력해주세요',
  'signIn.login.idSave': '아이디 저장',
  'signIn.join.1': '처음 오셨나요? ',
  'signIn.join.2': '회원가입하기',
  'signIn.join.3': '나야 회원이신가요?',
  'signIn.join.4': '로그인하기',
  'signIn.extra.1': '또는',
  'signIn.extra.TYPE_ADMIN': '직원 전용 로그인',
  'signIn.extra.TYPE_STAFF': '회사 계정으로 로그인',
  'error.BLANK_BUSINESS_NUMBER': '사업자번호를 입력해주세요',
  'error.BLANK_CONFIRM_PASSWORD': '비밀번호 확인을 입력해주세요',
  'error.BLANK_COMPANY_NAME': '회사명을 입력해주세요',
  'error.BLANK_MANAGER_NAME': '성함을 입력해주세요',
  'error.BLANK_MANAGER_PHONE': '휴대전화번호를 입력해주세요',
  'error.FALSE_AGREE_PRIVACY_USAGE': '개인정보 수집 및 이용동의를 체크해주세요',
  'error.IS_NOT_SAME_PASSWORD': '비밀번호가 서로 다릅니다',
  'error.PASSWORD_TOO_SHORT': '비밀번호를 6자 이상으로 만들어주세요',
  'error.ALREADY_JOINED': "이미 가입된 사업자번호입니다.\n나야 CS문의 1644-4908 또는 카카오톡 '나야 NAYA'",
  'recruitment.companyName': '회사명',
  'recruitment.companyName.placeholder': '회사명을 입력해주세요',
  'signIn.join.managerName': '성함',
  'signIn.join.managerName.placeholder': '성함을 입력해주세요',
  'signIn.join.managerPhone': '휴대전화번호',
  'signIn.join.managerPhone.placeholder': '(-)제외 휴대전화번호를 입력해주세요',
  'common.password2': '비밀번호 확인',
  'signIn.join.agreePrivacyUsage': '[필수] 개인정보 수집 및 이용동의',
  'signIn.join.subtitle': '서비스 가입을 위해 정보를 입력해주세요',
  'signIn.appDownload.google': 'Google Play',
  'signIn.appDownload.apple': 'App Store',
  'signIn.join.button': '회원가입 완료',
  'signIn.join.complete.message': '안녕하세요. {companyName}님!\n회원가입이 완료되었습니다.',
  'signIn.join.complete.button': '나야 시작하기',
  'error.COMMON_SIGN_IN': '아이디(사업자번호) 또는 비밀번호가 잘못 되었습니다.\n아이디와 비밀번호를 정확히 입력해 주세요.',
  'error.defaultError': '서버통신에 실패했습니다.',
  'sign.join': '회원가입',
  'signIn.join.from': '(선택) 가입경로',
  'signIn.join.from.placeholder': '어떻게 나야를 알게 되었나요?',
  'signIn.join.from.facebook': '페이스북',
  'signIn.join.from.instagram': '인스타그램',
  'signIn.join.from.referral': '지인 추천(직접입력)',
  'signIn.join.from.etc': '기타(직접입력)',
  'signIn.vi.phone.placeholder': '사업자번호 또는 휴대전화번호',
  'signIn.vi.phone.focus': '* ID: 기업회원은 사업자번호, 개인회원은 휴대전화번호',
  'error.COMMON_SIGN_IN_VI': '아이디 또는 비밀번호가 잘못 되었습니다. 정확히 입력해 주세요.',
  'signIn.join.select.type': '가입 유형을 선택해주세요',
  'signIn.join.company': '기업회원',
  'signIn.join.company.sub': '법인 및 사업체',
  'signIn.join.personal': '개인회원',
  'signIn.join.personal.sub': '사업자 없는 일반 사용자',
  'signIn.join.staff.method': '직원 회원가입 방법',
  'signIn.join.staff.sub':
    "직원은 관리자 회원을 통해 초대를 받아 이용할 수 있습니다.\n\n1. 나야 ERP 홈페이지에서 로그인하기\n2. 왼쪽 사이드바 최하단 ‘설정’ 버튼 클릭\n3. 사내직원관리 탭에서 '직원 신규등록' 버튼 클릭\n4. 직원 정보 입력 후 '등록완료' 누르면 완료됩니다.\n\n* 생성 후 직원마다 아이디가 부여됩니다. 직원 로그인 시 해당 직원 번호를 입력하시면 됩니다.",
  'signIn.join.phone.verify': '휴대전화번호 인증',
  'signIn.join.phone.message': '고객님의 휴대전화번호를 입력해주세요',
  'signIn.join.phone.verify.number': '인증번호',
  'signIn.join.phone.verify.send': '인증번호 전송',
  'signIn.join.phone.verify.input.placeholder': '인증번호 6자리를 입력해주세요',
  'signIn.join.phone.verify.resend': '재전송',
  'signIn.join.phone.error.verify.notMatch': '인증번호가 일치하지 않습니다.',
  'signIn.join.phone.error.verify.send': '인증번호가 전송되었습니다.',
  'signIn.join.phone.error.verify.resend': '인증번호가 재전송되었습니다.',
  'signIn.join.phone.verify.complete': '휴대전화번호 인증이 완료되었습니다.',
  'error.WRONG_FORMAT_PHONE': '휴대전화번호를 확인해주세요.',
  'signIn.join.phone.verify.complete.word': '인증완료',
  'signIn.join.referral': '(선택) 가입경로',
  'signIn.join.referral.placeholder': '어떻게 나야를 알게 되었나요?',
  'signIn.join.email': '(선택) 이메일',
  'signIn.join.email.placeholder': '이메일을 입력해주세요',
  'signIn.join.referral.facebook': '페이스북',
  'signIn.join.referral.instagram': '인스타그램',
  'signIn.join.referral.referral': '지인 추천',
  'signIn.join.referral.referral.label': '지인 추천(직접입력)',
  'signIn.join.referral.referral.placeholder': '추천인 이름 또는 상호를 입력해주세요',
  'signIn.join.referral.etc.label': '기타(직접입력)',
  'signIn.join.referral.etc': '기타',
  'signIn.join.referral.check': '중복확인',
  'signIn.join.referral.check.message': '회원가입 가능한 사업자번호입니다',
  'error.BUSINESS_NUMBER_NOT_VALID': "사업자번호 '중복 확인' 버튼을 눌러주세요",
  'error.BUSINESS_NUMBER_EXISTS': '이미 가입된 사업자번호입니다',
  'error.WRONG_FORMAT_BUSINESS_NUMBER': '올바른 사업자번호를 입력해주세요',
  'signIn.join.managerName2': '담당자 이름',
  'signIn.join.phone.verify.send.message': '인증번호가 전송되었습니다.',
  'signIn.join.phone.verify.resend.message': '인증번호가 재전송되었습니다.',
  'signIn.join.phone.verify.complete.message': '휴대전화번호 인증이 완료되었습니다.',
  'signIn.login.findPassword': '비밀번호 찾기',
  'signIn.join.5': '비밀번호가 기억난다면?',
  'signIn.join.phone.verify.title': '사업자 정보 인증',
  'signIn.join.phone.verify.sub': '본인 확인을 위해 가입 시 등록한\n사업자번호와 휴대전화번호를 입력해주세요.',
  'signIn.join.findPassword.title': '비밀번호 재설정',
  'signIn.join.findPassword.sub': '새 비밀번호를 설정해주세요',
  'signIn.join.findPassword.businessNumber': '사업자등록번호',
  'error.signIn.join.findPassword.businessNumber': '사업자번호와 전화번호를 확인해주세요',
  'signIn.join.phone.verify.complete.message.findPassword': '사업자 정보 인증 완료되었습니다.',
  'signIn.join.findPassword.complete.title': '비밀번호 설정 완료',
  'signIn.join.findPassword.complete.sub': '로그인 화면으로 이동하여\n새 비밀번호로 로그인 해보세요',
  'signIn.join.company.2': '기업 회원가입',
  'signIn.join.personal.2': '개인 회원가입',
  'error.PHONE_NUMBER_EXISTS': '이미 가입된 휴대전화번호입니다',
  'signIn.join.phone.verify.complete.message.findPassword.freelancer': '회원 정보 인증 완료되었습니다.',
  'signIn.join.consult': '문의하기',
  'signIn.findPassword.staff.method': '직원 비밀번호 찾는법',
  'signIn.findPassword.staff.sub':
    "관리자 회원을 통해 비밀번호 변경을 할 수 있습니다.\n\n1. 나야 ERP 홈페이지에서 로그인하기\n2. 왼쪽 사이드바 최하단 ‘설정’ 버튼 클릭\n3. 상단 탭 ‘사내직원관리’ 페이지에서 비밀번호 변경을 원하는 직원 클릭\n4. 수정하기를 누른 후 ‘비밀번호 변경' 누르면 신규 비밀번호를 설정할 수 있습니다.",
  'error.password.validate': '암호는 영문, 숫자, 특수문자 포함 6~15자로 설정해주세요.',
  'error.password.notMatch': '비밀번호가 동일하지 않습니다.',

  // sidebar & header
  'field.all': '전체 현장',
  'common.logout': '로그아웃',
  'sidebar.material.dashboard': '홈',
  'sidebar.material.field': '현장관리',
  'title.field': '현장관리',
  'consult.managingField': '현장관리',
  'title.setting': '설정',
  'sidebar.field.title': '나의현장',
  'sidebar.field.createButton': '새 현장',
  'sidebar.field.input.placeholder': '현장명, 주소 검색하기',
  'sidebar.material.field.create': '현장 생성',
  'sidebar.material.field.modify': '현장 수정',
  'popup.modifyField': '현장 수정',
  'field.name': '현장명',
  'field.workLog.detail.2': '현장명',
  'recruitment.portfolios.fieldName': '현장명',
  'consult.customer.create.fieldName.placeholder': '현장명을 입력해주세요',
  'common.address': '주소',
  'seller.address': '주소',
  'sidebar.field.update.address.placeholder': '주소를 검색해주세요',
  'sidebar.field.update.dateConstructStart.placeholder': '시작일 선택',
  'sidebar.field.update.dateConstructEnd.placeholder': '종료일 선택',
  'button.searchAddress': '주소 검색',
  'consult.button.customer.address': '주소 검색',
  'recruitment.portfolios.date': '공사 일정',
  'address.popup.search.placeholder': '예) 판교역로 166, 분당 주공, 백현동 532',
  'address.popup.empty.title': 'tip',
  'address.popup.empty.sub': '아래와 같은 조합으로 검색을 하시면 더욱 정확한 결과가 검색됩니다.',
  'address.popup.empty.example.title.1': '도로명 + 건물번호',
  'address.popup.empty.example.sub.1': '예) 판교역로 166, 제주 첨단로 242',
  'address.popup.empty.example.title.2': '지역명(동/리) + 번지',
  'address.popup.empty.example.sub.2': '예) 백현동 532, 제주 영평동 2181',
  'address.type.old': '지  번',
  'address.type.new': '도로명',
  'button.cancel': '취소',
  'profile.password.cancelled': '취소',
  'delivery.logiSpot.status.CANCELLED': '취소',
  'popup.customer.delete.cancel': '취소',
  'fileUpload.labelTapToCancel': '취소',
  'common.done': '완료',
  'title.common': '나야',
  'sidebar.field.empty.list': '에 해당하는 현장이 없습니다.',
  'field.guide.text': '여기서 현장을 변경하실 수 있어요',
  'field.add.update.cancel.create.title': '현장 생성을 중단할까요?',
  'field.add.update.cancel.title': '현장 설정을 중단할까요?',
  'field.add.update.address.search': '주소 검색하기',
  'field.add.update.customer.connect': '고객 연결',
  'field.add.update.customer.connect.button': '+ 고객 연결',
  'field.add.update.customer.connect.sub': '* 연결 시 현장보고, 상담일지, 채팅방, 첨부서류가 공유됩니다',
  'field.add.update.constructStatus.placeholder': '진행상황을 선택해주세요',
  'field.add.update.constructStatus': '진행상황',
  'field.add.update.spaceType': '현장유형',
  'field.add.update.spaceType.resident': '주거공간',
  'field.add.update.spaceType.commercial': '상업공간',
  'field.add.update.staff.placeholder': '현장 담당 직원을 선택해주세요',
  'field.add.update.spaceType.placeholder': '현장 공간유형(주거/상업)을 설정해주세요',
  'header.notification.title': '알림',
  'sidebar.notification.allRead': '전체읽음',
  // only korean
  'sidebar.sales.management': '영업관리',
  'sidebar.material.management': '발주 관리',
  'sidebar.material.budget': '자재예산관리',
  'sidebar.field.edit': '편집',
  'sidebar.field.create': '+ 현장 생성',
  'sidebar.field.year': '시공연도별',
  'sidebar.field.edit.title': '현장편집',
  'sidebar.field.edit.storage': '보관함',
  'sidebar.field.edit.hide': '현장 숨기기',
  'sidebar.field.edit.storage.title': '선택한 현장을 보관함에 숨길까요?',
  'sidebar.field.edit.storage.sub': '숨긴 현장은 보관함에서 복구 가능합니다',
  'sidebar.field.edit.storage.button': '숨기기',
  'sidebar.field.edit.storage.success': '✅ {count}개 현장을 보관함에 숨겼어요',
  'sidebar.field.edit.storage.restore': '복구하기',
  'sidebar.field.edit.storage.restore.title': '선택한 숨긴 현장을 복구할까요?',
  'sidebar.field.edit.storage.restore.sub': '복구한 현장은 리스트에 다시 노출됩니다',
  'sidebar.field.edit.storage.restore.success': '✅ 해당 현장이 복구되었어요',
  'sidebar.field.edit.storage.empty': '숨긴 현장이 없습니다',
  'internal.notice.title': '사내공지사항',
  'internal.notice.title.placeholder': '제목 검색',
  'internal.notice.field.no': '순서',
  'internal.notice.field.title': '제목',
  'internal.notice.field.title.placeholder': '제목을 입력해주세요.',
  'internal.notice.field.image': '사진첨부',
  'internal.notice.field.image2': '사진 첨부',
  'internal.notice.field.image.sub': '모든 이미지(png, jpg) 파일을 최대 10장까지 첨부가능합니다.',
  'internal.notice.field.body': '내용작성',
  'internal.notice.field.body.placeholder': '사내 전달사항을 작성해 주세요.\n작성 시 공지 대상, 주요 내용, 일정 등을 포함하면 좋습니다.',
  'internal.notice.field.view': '조회수',
  'internal.notice.field.more': '더보기',
  'internal.notice.field.file': '파일 첨부',
  'internal.notice.empty.title': '작성된 공지사항이 없습니다',
  'internal.notice.empty.button': '사내 공지사항 작성하기 >',
  'internal.notice.detail.title': '공지사항 상세',
  'internal.notice.detail.back': '목록으로',
  'internal.notice.create.title': '새 공지사항 작성',
  'internal.notice.create.cancel': '작성취소',
  'internal.notice.create.publish': '게시하기',
  'internal.notice.delete.title': '공지사항을 삭제할까요?',
  'internal.notice.delete.content': '한번 삭제하면 다시 복구할 수 없습니다.\n정말 삭제하시겠어요?',
  'internal.notice.delete.success': '삭제 완료되었습니다',
  'internal.notice.cancel.title': '저장하지 않은 내용은 사라집니다.\n취소하시겠어요?',
  'internal.notice.modify.title': '사내공지사항 수정',
  'internal.notice.modify.cancel': '수정취소',
  'internal.notice.modify.publish': '저장하기',
  'internal.notice.modify.required': '제목과 내용은 필수항목입니다.',
  'internal.notice.modify.publish.title': '해당 게시물을 올릴까요?',
  'internal.notice.modify.publish.sub': '업로드 후 게시물을\n수정 및 삭제 할 수 있습니다',
  'internal.notice.modify.publish.button': '올리기',
  'internal.notice.modify.publish.success': '게시 완료되었습니다',
  'internal.notice.modify.update.success': '수정 완료되었습니다',

  // dashboard
  'dashboard.all.date.noDate': '전체기간',
  'dashboard.all.date.noDate.end': '전체기간',
  'dashboard.field.revenue.total.1': '매출총액',
  'dashboard.field.expenses.total': '지출총액',
  'dashboard.field.profit.sum': '수익누계',
  'dashboard.field.profit.margin.average': '평균수익률',
  'dashboard.all.ledger.graph.table': '현장별 수익 비교',
  'dashboard.all.sort.graph.amountDesc': '수익 높은순',
  'dashboard.all.sort.graph.saleDesc': '매출 높은순',
  'dashboard.all.sort.graph.latest': '업데이트순',
  'dashboard.all.ledger.collection.table': '현장별 미수금',
  'dashboard.all.sort.collection.amountDesc': '금액 높은순',
  'dashboard.all.sort.collection.amountAsc': '금액 낮은순',
  'dashboard.all.sort.collection.latest': '업데이트순',
  'dashboard.all.ledger.table': '현장별 수익 순위',
  'dashboard.all.sort.amountDesc': '수익 높은순',
  'dashboard.all.sort.amountAsc': '수익 낮은순',
  'dashboard.all.sort.latest': '업데이트순',
  'dashboard.all.header.target': '목표달성률',
  'dashboard.all.ledger.noData': '현장손익 정보가 없습니다.',
  'dashboard.all.date.title': '기간 필터',
  'dashboard.all.date.confirm': '설정완료',
  'dashboard.all.date.header': '기간선택',
  'dashboard.all.date.header.tooltip': '공사 종료일이 없으면 반영되지 않으니\n반드시 기록해주세요.\n2개년도에 걸친 공사는\n종료된 해 기준으로 반영됩니다.',
  'dashboard.all.date.button.all': '전체',
  'dashboard.field.all': '전체',
  'search.all': '전체',
  'transactions.date.all': '전체',
  'consult.constructStatus.ALL': '전체',
  'consult.staff.ALL': '전체',
  'dashboard.all.date.button.year.this': '올해',
  'dashboard.all.date.button.year.last': '작년',
  'dashboard.all.date.field.all': '전체 현장 ',
  'dashboard.all.date.field.selected': '선택된 현장 ',
  'dashboard.all.date.field.no.date': '공사 종료일을 설정해주세요',
  'common.allShow.true': '더보기',
  'common.showMore': '더보기',
  'dashboard.tooltip.revenueCard': '작성한 매출의\n총 합계 금액입니다.',
  'dashboard.tooltip.expensesCard': '작성한 지출의\n총 합계 금액입니다.',
  'dashboard.tooltip.profitLossCard': '매출총액에서 지출총액을\n뺀 금액입니다.',
  'dashboard.tooltip.profitMarginCard.sum': '매출총액 대비\n수익누계의 비율입니다.',
  'common.allShow.false': '접기',
  'common.close': '접기',
  'work.accountancy.constructionFinishDate': '공사종료일',
  'sidebar.material.field.modify.date': '공사일정 수정',

  // dashboard/field
  'common.target': '목표',
  'common.under': '미달',
  'common.over': '초과',
  'budget.quantity.minus': '초과',
  'dashboard.field.over.budget': '초과',
  'common.none': '없음',
  'dashboard.tooltip.profitMarginCard': '매출총액 대비\n현장수익의 비율입니다.',
  'dashboard.field.profit': '현장수익',
  'dashboard.field.current.profit': '현장수익',
  'dashboard.field.input.update.account.book': '현장손익 입력/수정',
  'dashboard.field.sales': '매출',
  'dashboard.field.expenses': '지출',
  'dashboard.field.collections': '수금',
  'dashboard.field.profit.margin': '수익률',
  'dashboard.tooltip.receivables': '매출총액에서\n수금총액을 뺀 금액',
  'dashboard.tooltip.currentProfit': '매출총액에서\n지출총액을 뺀 금액',
  'dashboard.field.revenue.total.2': '매출총액(계약금액)',
  'dashboard.field.receivables': '미수금',
  'dashboard.field.receivables.total': '미수금총액',
  'dashboard.field.expenses.budget': '지출예산',
  'dashboard.field.target.profit': '목표수익',
  'dashboard.field.under.budget': '남음',
  'budget.quantity.plus': '남음',
  'dashboard.field.expenses.budget.total': '예산총액',
  'dashboard.field.material.expenses': '재료비',
  'dashboard.field.labor.expenses': '직영노무비',
  'dashboard.field.labor.expenses1': '직영노무비',
  'dashboard.field.outsourcing.expenses': '외주비',
  'dashboard.field.extra.expenses': '경비',
  'dashboard.field.budget.comparison': '예산대비',
  'dashboard.field.management': '현장 관리 기능',
  'dashboard.field.chat': '채팅방',
  'dashboard.field.chat.inner': '사내 채팅방',
  'dashboard.field.chat.customer': '고객 채팅방',
  'dashboard.field.file': '서류보관함',
  'dashboard.field.report': '현장보고',
  'dashboard.field.staff': '직원관리',
  'dashboard.field.consult': '상담노트',
  'dashboard.field.calendar': '일정관리',
  'dashboard.field.profile': '내정보',
  'field.info.update': '정보 수정',
  'field.info.staff': '담당직원',
  'dashboard.field.info.staff': '담당직원',
  'field.staff': '담당직원',
  'field.info.construction.period': '공사기간',
  'dashboard.field.info.construction.period': '공사기간',
  'field.info.memo': '기타메모',
  'dashboard.field.info.memo': '기타메모',
  'field.info': '현장정보',

  // field/work-logs
  'field.title.log.simple': '현장보고',
  'field.workLog.add': '작성하기',
  'field.workLog.empty.message': '등록된 현장보고가 없습니다.\n현장보고를 등록해주세요!',
  'common.fill.blank': '항목을 입력해주세요.',
  'title.field.workLogs.add': '현장보고서 작성',
  'title.field.workLogs.update': '현장보고서 수정',
  'field.workLogs.name': '작업 공간',
  'field.workLogs.content': '작업 내용',
  'err.image.FileTooLarge': '파일 크기가 너무 큽니다.',
  'field.workLogs.name.list.placeholder': '기존 공간 선택',
  'field.workLogs.name.list.empty': '등록된 공간이 없습니다.',
  'field.workLogs.name.placeholder': '작업 공간을 입력해주세요.',
  'title.field.workLogs': '현장보고',
  'title.field.workLogs.comment.add': ' 댓글 작성하기',
  'field.workLogs.date': '공사일',
  'field.workLogs.image': '현장 사진',
  'button.add': '추가',
  'button.close': '닫기',
  'popup.customer.detailInfo.noty.cancel': '닫기',
  'button.modify': '수정',
  'button.delete': '삭제',
  'sidebar.material.field.detail': '현장 상세',
  'field.date': '일자',
  'common.date': '일자',
  'recruitment.companyHistories.date': '일자',
  'image.limit.message': '30개까지 추가 가능합니다.',
  'field.workLogs.add.button': '새 현장보고 작성',
  'field.workLogs.empty.1': '작성된 현장보고가 없습니다.',
  'field.workLogs.empty.2': '첫번째 현장보고를 {name}님이 먼저 작성해보세요!',
  'field.workLogs.empty.button': '새 현장보고 작성하기',
  'field.workLogs.comment': '댓글',
  'field.workLogs.name.all': '공간 전체',
  'field.workLogs.comment.placeholder': '댓글을 작성해주세요',
  'field.workLogs.comment.empty': '작성된 댓글이 없습니다',
  'field.workLogs.add.popup.title': '현장보고 작성',
  'field.workLogs.add.popup.content.title': '공간',
  'field.workLogs.add.popup.content.date': '보고일자',
  'field.workLogs.add.popup.content.space.placeholder': '공간을 선택해주세요',
  'field.workLogs.add.popup.content.space.add': '+ 공간 추가하기',
  'field.workLogs.add.popup.content.space.name.placeholder': '공간명을 입력해주세요',
  'field.workLogs.add.popup.content.update': '현장보고 수정',
  'field.workLogs.delete.confirm': '정말 해당 현장보고를\n삭제하시겠어요?',
  'field.workLogs.delete.success': '해당 현장보고를 삭제했습니다',
  'field.workLogs.image.error': '한 장 이상의 현장 사진을 추가해 주세요',
  'field.workLogs.content.short': '간략하게 보기',
  'field.workLogs.content.long': '자세히 보기',
  'field.workLogs.list': '목록',
  'field.workLogs.current': '현재 보는 중',

  // field/comment
  'field.comment.noty': '모든 시공팀이 볼 수 있는 공개 대화방입니다.',
  'field.comment.noty.true': '앱 푸시알림을 켭니다.',
  'field.comment.noty.false': '앱 푸시알림을 끕니다.',
  'dropzone.noty.free': '이미지를 이곳에 끌어놓거나 클릭해서 업로드하기',
  'field.comment.noty2': '나야 서버는 메시지를 삭제하더라도 모든 대화 내용을 보관합니다',
  'common.dont.see': '다시 보지 않기',
  'field.comment.placeholder': '코멘트 새로 작성하기',
  'field.comment.noNoty': '알람 꺼짐',
  'field.comment': '채팅방',
  'field.comment.title.comment': '사내채팅방',
  'field.comment.title.surComment': '통합채팅방',
  'field.comment.title.clientComment': '고객채팅방',
  'common.addImage': '이미지 추가',
  'field.document.photo': '사진',
  'common.send': '전송',
  'common.client': '고객',
  'field.comment.noMessage': '메시지가 없습니다.',
  'field.comment.member': '멤버',
  'field.comment.me': '나',
  'field.comment.placeholder.content': '내용을 입력해주세요.',
  'field.comment.delete.confirm': '정말 삭제하시겠어요?',
  'consult.checkList.spaces.uncheck.2': '정말 삭제하시겠어요?',
  'field.comment.addImage.title': '이미지 전송',
  'field.comment.addImage.placeholder': '여기에 이미지를 놓아주세요\n직접 첨부를 원하시면',
  'field.comment.addImage.placeholder.button': '여기를 클릭해주세요',
  'field.comment.addImage.drag.placeholder': '아무 곳에나\n파일을 놓으세요',
  'field.comment.addImage.attachments': '이미지첨부',
  'field.comment.empty': '아직 작성된 채팅이 없습니다.\n{name} 님이 먼저 인사해보세요! 👋',

  // field/document
  'title.field.document': '서류보관함',
  'field.document.name': '서류이름',
  'field.document.dateCreated': '작성일',
  'common.creator': '작성자',
  'field.workLog.detail.7': '작성자',
  'field.minutesOfMeetings.writer': '작성자',
  'field.contract.writer': '작성자',
  'title.field.document.add': '첨부서류 추가',
  'title.field.document.update': '첨부서류 수정',
  'common.update.delete': '수정/삭제',
  'message.delete': '삭제하시겠습니까?',
  'field.document.add': '새 첨부서류 등록',
  'field.document.name.and.file': '서류 및 파일명',
  'work.file': '첨부파일',
  'field.document.detail': '자세히',
  'field.document.file.count': '파일 {count}개',
  'field.document.file.download': '파일 다운로드',
  'consult.button.edit': '수정하기',
  'popup.customer.delete.confirm': '삭제하기',
  'field.document.add.popup.title': '첨부서류 등록',
  'field.document.name.title': '서류명',
  'field.document.file.title': '서류파일',
  'field.document.name.placeholder': '서류 이름을 입력해주세요',
  'field.document.update.popup.title': '첨부서류 수정',
  'field.document.delete.confirm': '정말 해당 첨부서류를\n삭제하시겠어요?',
  'field.document.delete.success': '해당 첨부서류를 삭제했습니다',
  'field.document.add.success': '첨부서류를 등록했습니다',
  'field.document.update.success': '첨부서류를 수정했습니다',

  // field/setting
  'basic.info': '기본정보',
  'field.date.start.end': '공사일정',
  'field.date.start.end.empty': '공사일정을 설정해주세요',
  'field.staff.num': '직원 수',
  'search.active': '사용여부',
  'material.active': '사용여부',
  'common.active': '사용여부',
  'search.createdAt': '등록일',
  'order.dateCreated': '등록일',
  'sellerGroup.dateCreated': '등록일',
  'field.dateCreated': '현장생성일',
  'field.staff.update': '담당 직원 입력',
  'user.name': '이름',
  'seller.name': '이름',
  'common.name': '이름',
  'search.name': '이름',
  'common.phone': '연락처',
  'search.phone': '연락처',
  'seller.address2': '상세 주소',
  'common.address2': '상세 주소',
  'field.date.start.option': '공사 시작일(선택사항)',
  'field.date.end.option': '공사 종료일(선택사항)',
  'user.active': '사용가능여부',
  'widgets.search': '검색',
  'button.search': '검색',
  'widgets.reset': '초기화',
  'button.select': '선택',
  'common.id': '아이디',
  'staff.fields.num': '담당 현장 수',
  'seller.dateCreated': '가입일',
  'common.showAddress': '주소 확인',
  'error.field.empty': '현장명, 주소, 상세 주소, 사용여부는 필수 항목입니다.',
  'address.placeholder': '주소를 입력해주세요.',
  'common.info': '정보',
  'field.input.staff': '현장 담당직원',
  'field.staff.setting': '설정하기',
  'field.staff.empty': '위 현장에 담당직원이 없습니다.',
  'field.staff.empty.button': '담당직원 설정하기 >',
  'field.basic.info': '현장 기본정보',
  'field.basic.info.setting': '현장 기본정보 설정',
  'field.staff.update.title': '현장 담당직원 설정',
  'field.staff.add': '직원 신규등록',
  'field.staff.update.popup.filter.name': '직원 이름 검색',
  'field.staff.update.popup.filter.phone': '연락처 검색',
  'field.staff.update.popup.header.title': '총 직원 수',
  'field.staff.update.popup.button.save': '선택한 {count}명 저장하기',
  'settings.customer.register.tooltip': '고객 등록 시 현장보고, 상담일지, 채팅방,\n서류보관함이 공유되며 이외 페이지는 공유되지 않습니다.',
  'settings.customer.register.button': '연결하기',
  'settings.customer.register.status': '연결 상태',
  'settings.customer.register.empty': '연결된 고객이 없습니다.\n연결 시 현장보고, 상담일지, 채팅방, 서류보관함만 공유됩니다',
  'settings.customer.register.empty.button': '고객 연결하기 >',
  'settings.customer.register.search.empty': '검색결과가 없습니다. 고객 아이디를 확인해주세요',
  'settings.customer.register.phone': '고객 휴대전화번호',
  'settings.customer.register.search.guest': '님은 비회원 고객입니다.\n초대하기를 누른 후, 고객님께 링크를 공유해주세요!',
  'settings.customer.register.share': '공유하기',
  'settings.customer.invite.success': '고객님께\n현장 초대를 보냈어요! 💌',
  'settings.customer.invite.success.suffix': '! 💌',
  'settings.guest.invite.success': '\n위 번호로 현장 초대를 보냈어요! 💌',
  'settings.guest.invite.success.text.1': '공유하기를 눌러 고객님께 앱 다운로드 링크를 보내면\n더 편리하게 서비스를 이용할 수 있습니다.',
  'settings.guest.invite.success.text.2': '고객이 회원가입 시 앱에서\n아래와 같은 초대 메세지를 받게됩니다',
  'settings.customer.invite.success.text.1': '고객님 앱으로 현장 초대 알림을 보냈습니다',
  'settings.customer.invite.success.text.2': '고객이 로그인 시 앱에서\n아래와 같은 초대 메세지를 확인할 수 있습니다',
  'settings.guest.copy.text.prefix': '[NAYA] ',
  'settings.guest.copy.text.suffix': '에서 현장 초대를 보냈습니다.\n아래 링크를 눌러 실시간 현장 보고를 받아보세요!\n',
  'settings.guest.copy.success': '복사되었습니다.',

  // setting
  'account.info': '계정정보',
  'profile.password.change': '비밀번호 변경',
  'profile.password.old': '기존 비밀번호',
  'profile.password.new': '새로운 비밀번호',
  'profile.password.confirmNew': '새로운 비밀번호 확인',
  'profile.password.same': '일치합니다.',
  'profile.password.notSame': '일치하지 않습니다.',
  'profile.password.confirm': '확인',
  'button.confirm': '확인',
  'profile.password.condition': '영문/숫자 포함 6~15자',
  'profile.password.emptyOld': '기존 비밀번호를 입력해 주세요.',
  'profile.password.emptyNew': '새로운 비밀번호를 입력해 주세요.',
  'profile.password.not': '비밀번호가 일치하지 않습니다.',
  'profile.password.notPattern': '새로운 비밀번호를 다시 확인해 주세요.',
  'profile.password.success': '비밀번호 변경이 완료되었습니다.',
  'userInfo.email': '대표 이메일',
  'seller.companyName': '상호',
  'seller.phone': '사업자번호',
  'seller.businessOwner': '대표자',
  'seller.typeOfBusiness': '업태',
  'seller.itemsOfBusiness': '종목',
  'common.staff': '담당자',
  'order.staff': '담당자',
  'common.info.refund.transfer': '환불 계좌정보',
  'sidebar.material.user': '직원등록/수정',
  'staff.info': '직원정보',
  'staff.birth.option': '생년월일(선택 사항)',
  'staff.date.entered.resignation.option': '입사 / 퇴사일(선택 사항)',
  'seller.memo.option': '메모(선택 사항)',
  'sidebar.material.user.detail': '직원 상세',
  'sidebar.material.user.create': '직원 생성',
  'sidebar.material.user.modify': '직원 수정',
  'staff.date.entered.resignation': '입사 및 퇴사일',
  'staff.birth': '생년월일',
  'staff.fields': '담당현장',
  'button.ChangePassword': '비밀번호 수정',
  'button.update': '업데이트',
  'partner.name': '업체명',
  'button.create': '생성',
  'seller.memo': '메모',
  'company.info': '업체정보',
  'sidebar.material.userInfo': '사용자 정보',
  'button.searchStaff': '직원 검색',
  'error.user.empty': '이름, 전화번호, 비밀 번호, 권한유무는 필수 항목입니다.',
  'error.user.modify.empty': '이름, 전화번호, 권한유무는 필수 항목입니다.',
  'error.password.INVALID_PASSWORD': '기존 비밀번호가 일치하지 않습니다.',
  'password.change.message': '변경되었습니다.\n다시 로그인 해주세요.',
  'common.yes': '예',
  'common.no': '아니오',
  'setting.my.info': '내 정보',
  'setting.company.info': '회사 정보',
  'setting.fields.num': '{count}개',
  'setting.profile.image.change': '이미지변경',
  'setting.profile.image': '프로필 이미지',

  // account-book
  'dashboard.field.account.book': '현장손익',
  'dashboard.field.account.book.add': '현장손익 작성',
  'dashboard.field.account.book.sort.latest': '최신순',
  'field.minutesOfMeetings.date.-dateMeeting': '최신순',
  'dashboard.field.account.book.sort.oldest': '과거순',
  'dashboard.field.account.book.type.all': '유형 전체',
  'dashboard.field.account.book.empty': '현장손익 작성하기',
  'dashboard.field.account.book.sales.empty': '매출 작성하기',
  'dashboard.field.account.book.expenses.empty': '지출 작성하기',
  'dashboard.field.account.book.collections.empty': '수금 작성하기',
  'dashboard.field.budget.request': '예산요청',
  'dashboard.field.account.book.category.all': '구분 전체',
  'dashboard.field.account.book.no': 'No.',
  'dashboard.field.account.book.date': '작성일',
  'dashboard.field.account.book.type': '유형',
  'dashboard.field.account.book.category': '구분',
  'consult.order.drawing.noty.column.type': '구분',
  'order.history.type': '구분',
  'order.cancel.item.type': '구분',
  'order.return.item.type': '구분',
  'dashboard.field.account.book.description': '내용',
  'dashboard.field.account.book.description.CATEGORY_SALES': '내용',
  'nayaBoard.content': '내용',
  'recruitment.companyHistories.content': '내용',
  'dashboard.field.account.book.amount': '금액',
  'material.refund.amount': '금액',
  'order.cancel.item.sum': '금액',
  'order.return.item.sum': '금액',
  'order.amount': '금액',
  'field.ammount': '금액',
  'dashboard.field.amount': '금액',
  'dashboard.field.account.book.new': '새 현장손익 작성',
  'dashboard.field.account.book.date.common': '날짜',
  'dashboard.field.account.book.contract.amount': '계약금액',
  'dashboard.field.account.book.amount.without.tax': '금액(부가세 별도)',
  'dashboard.field.account.book.expense.category': '지출 구분',
  'dashboard.field.account.book.expense.select': '지출을 선택해주세요',
  'dashboard.field.account.book.cancel.title': '새 현장손익 작성을 중단할까요?',
  'dashboard.field.account.book.cancel.content': '중단 시 작성한 내용은 저장되지 않습니다',
  'dashboard.field.account.book.cancel.button': '네',
  'dashboard.field.account.book.update': '현장손익 수정',
  'dashboard.field.account.book.update.cancel': '현장손익 수정을 중단할까요?',
  'dashboard.field.account.book.update.content': '중단 시 수정한 내용은 저장되지 않습니다',
  'dashboard.field.account.book.delete': '현장손익을 삭제할까요?',
  'dashboard.field.account.book.delete.content': '삭제 시 작성한 내용을 복구할 수 없습니다',
  'dashboard.field.account.book.restore': '복구하기',
  'dashboard.field.account.book.restore.title': '삭제한 현장손익을 복구할까요?',
  'dashboard.field.account.book.restore.content': '복구하면 현장손익 목록에 다시 표시됩니다',
  'dashboard.field.account.book.budget.setting': '지출예산 설정',
  'dashboard.field.account.book.description.placeholder': '내용을 작성해주세요',
  'dashboard.field.account.book.search.result': '검색결과',
  'dashboard.field.account.book.search.placeholder': '내용 검색',
  'dashboard.field.account.book.amount.total': '총',
  'dashboard.field.account.book.search.empty': '에 해당하는 검색결과가 없습니다.',
  'dashboard.field.account.book.budget.setting.placeholder': '지출 목표 금액을 입력해주세요',
  'field.contract.placeholder.date': '날짜를 선택해주세요',
  'field.contract.placeholder.price': '금액을 입력해주세요',
  'dashboard.field.account.book.example': '예시',
  'dashboard.field.account.book.onboarding.start': '현장 손익 관리 시작하기',
  'dashboard.field.account.book.onboarding.title': '현장 손익 관리 시작하기',
  'dashboard.field.account.book.onboarding.description': '지금까지 진행했던 현장의 계약금\n지출, 수금 누계를 한번에 입력해보세요.',
  'dashboard.field.account.book.onboarding.vat.notice': '(VAT를 제외한 금액으로 입력하세요)',
  'dashboard.field.account.book.onboarding.sumSales': '계약금액 (매출 총액)',
  'dashboard.field.account.book.onboarding.sumCollections': '수금 누계',
  'dashboard.field.account.book.onboarding.sumPurchase': '지출 누계',
  'dashboard.field.account.book.onboarding.sumExpenseBudget': '예산 (지출 총 목표 금액)',
  'dashboard.field.account.book.onboarding.skip.hint': '새로 시작하는 현장이라면 건너뛰어도 괜찮습니다',
  'dashboard.field.account.book.onboarding.skip': '건너뛰기',
  'dashboard.field.account.book.onboarding.submit': '현장 손익 관리 시작',
  'dashboard.field.account.book.onboarding.skip.confirm.title': '작성 중인 내용을 무시하고 건너뛸까요?',
  'dashboard.field.account.book.onboarding.skip.confirm.content': '현재 작성한 내용이 저장되지 않습니다.',
  'dashboard.field.account.book.onboarding.discard.title': '작성 중인 내용을 삭제할까요?',
  'dashboard.field.account.book.onboarding.discard.content': '삭제한 내용은 저장되지 않습니다.',
  'dashboard.field.account.book.onboarding.discard': '삭제',
  'account.book.dummy.1': '계약',
  'account.book.dummy.2': '추가 계약',
  'account.book.dummy.3': '선급금',
  'account.book.dummy.4': '1차 중도금',
  'account.book.dummy.5': '2차 중도금',
  'account.book.dummy.6': '식비',
  'account.book.dummy.7': '일반 석고보드: 9.5T * 900 * 1800',
  'account.book.dummy.8': '선급금',
  'dashboard.field.account.book.image': '첨부사진',
  'dashboard.field.account.book.receipt': '영수증 첨부',
  'dashboard.field.account.book.image.placeholder': '사진 첨부',

  // ! 베트남 사용구분 =========================================================================================

  // consult
  'consult.title.search': '고객검색',
  'consult.title.create': '신규상담',
  'consult.input.search.placeholder': '고객명, 휴대전화번호, 주소 등 검색',
  'consult.customer.search.result': '명이 검색되었습니다.',
  'consult.button.create.customer': '신규 상담',
  'consult.button.layout.type.dashboard': '대시보드형',
  'consult.button.layout.type.list': '리스트형',
  'consult.button.save': '저장하기',
  'consult.button.prev': '이전',
  'consult.button.next': '다음',
  'consult.button.order.drawing': '신청하기',
  'consult.button.addSpace': '+ 공간 추가하기',
  'consult.customer.files': '첨부 파일',
  'consult.customer.files2': '추가 파일',
  'consult.customer.files.button': '+ 파일 첨부\n클릭 혹은 이곳에 드롭하세요',
  'consult.customer.work.files.button': '+ 사진 첨부하기',
  'consult.customer.files.info': '* 첨부 파일은 pdf, png, jpg만 가능합니다',
  'consult.title.customer': '고객상담',
  'consult.title.extra': '추가정보',
  'consult.title.info.modify': '고객기본정보',
  'consult.title.checkList': '상담정보',
  'consult.title.designDownload': '디자인 다운로드',
  'consult.customer.add': '+ 신규 상담 등록',
  'consult.customer.empty': '등록한 고객이 없습니다',
  'consult.customer.searchWord': '최근 검색어',
  'consult.customer.searchWord.noData': '최근 검색한 고객이 없습니다',
  'consult.customer.info.name': '고객명(발주처명)',
  'consult.customer.info.basic': '고객기본정보',
  'consult.customer.info.genderAndAgeRange': '성별/나이대',
  'consult.customer.info.dateCreated': '상담일자',
  'consult.customer.info.status': '상담상태',
  'consult.customer.create.name': '고객명(발주처명)',
  'consult.customer.create.name.placeholder': '고객님의 성함 또는 회사명을 입력해주세요',
  'consult.customer.create.address': '현장주소',
  'consult.customer.create.address.placeholder': '주소지를 입력해주세요',
  'consult.customer.create.address2.placeholder': '상세 주소를 입력해주세요',
  'consult.customer.create.dateStart': '공사 시작(예정)일',
  'consult.customer.create.dateStart.placeholder': '날짜 선택하기',
  'consult.customer.create.phone': '휴대전화번호',
  'consult.customer.create.phone.placeholder': '(-)빼고 숫자만 입력해주세요',
  'consult.customer.create.email': '이메일(선택)',
  'consult.customer.create.email.placeholder': '고객님의 이메일을 입력해주세요',
  'consult.customer.create.fieldName': '현장명(선택)',
  'consult.customer.create.policyAgree': '[필수] 개인정보 수집 및 이용동의',
  'consult.customer.create.button.confirm': '입력 완료',
  'consult.customer.create.button.edit': '수정 완료',
  'consult.customer.create.error.name': '고객명을 입력해주세요',
  'consult.customer.create.error.fieldType': '현장유형을 선택해주세요',
  'consult.customer.create.error.residentialType': '주거공간 유형을 선택해주세요',
  'consult.customer.create.error.address': '주소를 입력해주세요',
  'consult.customer.create.error.address2': '상세 주소를 입력해주세요',
  'consult.customer.create.error.latLong': '주소에 오류가 있습니다\n다른 주소를 선택해주세요',
  'consult.customer.create.error.dateStart': '공사 시작(예정)일을 입력해주세요',
  'consult.customer.create.error.phone': '휴대전화번호를 입력해주세요',
  'consult.customer.create.error.gender': '성별을 선택해주세요',
  'consult.customer.create.error.age': '고객 연령대를 선택해주세요',
  'consult.customer.info.customerConsult.title': '상담하기',
  'consult.customer.info.customerConsult.title2': '고객 상담 시 함께 작성하세요',
  'consult.customer.info.detailInfo.title': '시공사전용',
  'consult.customer.info.detailInfo.title2': '디자인/견적 시 필요한 정보를 작성해요',
  'consult.customer.info.proposal.title': '디자인 제안서',
  'consult.customer.info.proposal.title2': '의뢰하기 >',
  'consult.customer.info.drawing.title': '3D 투시도',
  'consult.customer.info.drawing.title2': '의뢰하기 >',
  'consult.customer.info.designDownload.title': '디자인 다운로드',
  'consult.customer.info.designDownload.title2': '의뢰한 디자인 제안서와 3D투시도를\n다운로드 받아요',
  'consult.customer.info.label.dateStart': '시공 예정일',
  'consult.customer.info.label.consultLog': '상담일자',
  'consult.customer.consult.title': '상담내역',
  'consult.customer.consult.title2': '작성한 내역을 확인해보세요',
  'consult.customer.consult.basicInfo': '현장 정보',
  'consult.customer.consult.basicInfo.demolitions': '철거',
  'consult.customer.consult.basicInfo.temporaryWorks': '가설',
  'consult.customer.consult.basicInfo.spaceSizes': '평형',
  'consult.customer.consult.basicInfo.spaces': '시공 공간',
  'consult.customer.consult.basicInfo.spaceSituations': '공간 상황',
  'consult.customer.consult.basicInfo.styles': '스타일',
  'consult.customer.consult.workInfo.commercial': '미팅 내역',
  'consult.customer.consult.workInfo.commercial.detail.title': '상담 내용',
  'consult.customer.consult.basicInfo.null': ' 선택하기',
  'consult.customer.consult.spaces.material.null': '자재 선택하기',
  'consult.customer.consult.spaces.material.commercial': '자세한 상담 내용을 메모해주세요',
  'consult.customer.edit.success.title': '수정이 완료되었습니다.',
  'consult.customer.detailInfo.budgets': '추정 평당 예산(중복 선택 가능, 필수)',
  'consult.customer.detailInfo.memo.label': '기타(메모, 필수)',
  'consult.customer.detailInfo.memo.placeholder':
    '고객님과 잘 상담하셨나요?\n디자인 또는 견적 요청 관련하여 참고할 사항을 나야에게 알려주세요.\n상담때 사용한 평면도 이미지와 고객 특성을 입력해주세요.\n\nEX. 디자인에 매우 관심이 높음',
  'consult.checkList.title.residential.demolitions': '시공 전, 철거가 필요한 부분을 선택해주세요',
  'consult.checkList.title.residential.temporaryWorks': '필요한 가설을 선택해주세요',
  'consult.checkList.title.residential.spaceSizes': '공간 평형을 선택해주세요(전용면적 기준)',
  'consult.checkList.title.residential.spaces': '공사 할 공간을 모두 선택해주세요',
  'consult.checkList.title.residential.spaces.all': '전체 공간 선택',
  'consult.checkList.title.residential.spaceSituations': '공간의 상황을 선택해주세요',
  'consult.checkList.title.residential.styles': '원하는 스타일을 골라주세요\n중복선택 가능합니다',
  'consult.checkList.title.material.yesOrNo': '시공하시나요?',
  'consult.checkList.title.commercial.demolitions': '시공 전, 철거가 필요한 부분을 선택해주세요',
  'consult.checkList.title.commercial.temporaryWorks': '필요한 가설을 선택해주세요',
  'consult.checkList.title.commercial.spaceSizes': '공간 평형을 선택해주세요(전용면적 기준)',
  'consult.checkList.title.commercial.spaces': '시공 할 공간을 선택해주세요',
  'consult.checkList.title.commercial.spaceSituations': '공간의 상황을 선택해주세요',
  'consult.checkList.work.text.label': '기타(메모)',
  'consult.checkList.work.text.placeholder': '특별히 원하시는 컬러, 가격대, 브랜드가 있을 경우 메모해주세요\n(이미지가 있으면 아래 첨부해주세요)',
  'consult.order.proposal.title': '제안서에 들어갈 3D투시도\n공간을 선택해주세요',
  'consult.order.drawing.title': '3D투시도로 만들고싶은\n공간을 선택해주세요',
  'consult.order.proposal.subtitle1': '2컷까지 무료 (',
  'consult.order.proposal.subtitle2': '/2)',
  'consult.order.drawing.subtitle': '* 디자인필요\n* 같은 공간에 뷰가 2개 이상 추가되는 경우 요청 사항에 적어주세요.',
  'consult.order.space.custom': '기타(직접입력)',
  'consult.order.space.nickName': '어떤 용도의 공간인가요',
  'consult.order.space.add.title': '공간 추가하기',
  'consult.order.drawing.label': '도면(필수)',
  'consult.order.drawing.memo': '요청사항',
  'material.delivery.memo': '요청사항',
  'consult.order.commercial.drawing.memo.placeholder': '요청사항이 있다면 여기에 적어주세요',
  'consult.order.drawing.price.title': '결제 예정 금액',
  'consult.order.drawing.price.label': '기본 상품',
  'consult.order.proposal.price.additional.label': '추가 상품',
  'consult.order.proposal.price.member': '회원가',
  'consult.order.proposal.price.nonMember': '비회원가',
  'consult.order.proposal.price.included': '무료',
  'consult.order.proposal.priceSum.label': '최종 결제금액',
  'consult.order.drawing.noty.title': '안내 및 동의',
  'consult.order.drawing.noty.residential.content.title': '본인은 안내된 (주)씨투와이 NAYA(나야)의 업무 규정에 따라\n디자인을 제공받기로 하며 다음 사항에 동의합니다.',
  'consult.order.drawing.noty.period.title': '1. 제작 일정',
  'consult.order.drawing.noty.column.type.drawing': '3D투시도',
  'consult.order.drawing.noty.column.type.drawing.suffix': '(컷 당)',
  'consult.order.drawing.noty.column.type.proposal': '디자인 제안서',
  'consult.order.drawing.noty.column.period': '소요기간',
  'consult.order.drawing.noty.column.period.drawing': '2~4일(영업일 기준)',
  'consult.order.drawing.noty.column.period.proposal': '5~7일(영업일 기준)',
  'consult.order.drawing.noty.price.title': '2. 디자인 제작비',
  'consult.order.drawing.noty.column.price.nonMember': '정상가',
  'consult.order.drawing.noty.column.price.nonMember.drawing': '18만원',
  'consult.order.drawing.noty.column.price.nonMember.proposal': '80만원',
  'consult.order.drawing.noty.column.price.member': '회원가',
  'consult.order.drawing.noty.column.price.member.drawing': '9만원',
  'consult.order.drawing.noty.column.price.member.proposal': '35만원',
  'consult.order.drawing.noty.price.sum': '총 제작비',
  'consult.order.drawing.noty.price.payment': '선급 결제',
  'consult.order.drawing.noty.price.remains': '잔금',
  'consult.order.drawing.noty.price.payback': '무료조건',
  'consult.order.drawing.noty.price.memo': '최종결제금액',
  'consult.order.drawing.noty.column.etc': '비고',
  'consult.order.drawing.noty.column.etc.label': '면적이 넓거나\n상업시설인 경우\n추가비용 발생가능',
  'consult.order.drawing.noty.etc.title': '기타',
  'consult.order.drawing.noty.etc.label': '1) 투시도 및 제안서 일부 수정은 2회까지 무료 / 이후 회원가 적용됩니다\n2) 제작 및 납품되는 모든 디자인 저작권은 나야(NAYA)에게 있습니다',
  'consult.order.drawing.noty.right.title': '3. 디자인 저작권',
  'consult.order.drawing.noty.right.label': '디자인의 저작권은 NAYA(나야)에 귀속되며, “의뢰한 현장 시공" 이외 목적으로\n사용할 수 없습니다. 이를 위반 시 그에대한 손해를 배상하기로 합니다.',
  'consult.order.drawing.agree': '[필수] 위 내용 모두 숙지하였으며, 모두 동의합니다',
  'consult.order.drawing.agree.popup.title': '내용을 충분히 이해하셨나요?',
  'consult.order.drawing.agree.popup.content': '설명 내용을 제대로 이해하지 못했는데도\n이해했다고 확인하는 경우, 추후 해당 내용과\n관련한 권리구제가 어려울 수 있어요',
  'consult.order.drawing.agree.popup.button': '네, 충분히 이해했어요',
  'consult.design.request': '의뢰',
  'consult.design.download.title': '디자인 다운로드',
  'consult.design.download.info': '*디자인 원본파일은 ',
  'consult.design.download.info2': 'CRM>고객상담>디자인 주문상세내역',
  'consult.design.download.info3': '에서 결제 후 다운로드를 할 수 있습니다',
  'consult.design.payment.request': '결제하고 디자인을 확인해보세요',
  'consult.design.payment.request.button': '결제하기',
  'consult.design.order.label': '주문 상품',
  'consult.design.order.price.sum': '주문 금액',
  'consult.design.info.title': '기본 의뢰정보',
  'consult.design.info.status': '주문상태',
  'consult.design.info.product': '주문상품',
  'consult.design.info.dateCreated': '주문일시',
  'consult.design.info.dateWorking': '작업일시',
  'consult.design.payment.price': '결제 금액',
  'consult.design.payment.datePaid': '결제 일시',
  'consult.design.payment.method': '결제 방법',
  'payment.method': '결제 방법',
  'consult.design.payment.amount': '주문 금액',
  'consult.design.payment.amountVAT': '부가세',
  'consult.design.payment.amountSum': '총 결제 금액',
  'consult.design.chat.title': '요청 사항',
  'consult.payment.title': '결제',
  'consult.payment.select.title': '결제 수단을 선택해주세요',
  'consult.payment.virtual.title': '무통장입금 결제하기',
  'consult.payment.method.VIRTUAL_ACCOUNT': '무통장입금',
  'consult.payment.method.CARD': '카드 결제',
  'consult.payment.virtual.customerName': '입금자명*',
  'consult.payment.virtual.customerName.placeholder': '입금자명을 입력해주세요',
  'consult.payment.virtual.bank': '입금계좌 은행*',
  'consult.payment.virtual.bank.placeholder': '은행 선택',
  'consult.payment.virtual.email': '이메일',
  'common.email': '이메일',
  'consult.payment.virtual.email.placeholder': '결제 정보 받을 이메일을 입력해주세요',
  'consult.payment.virtual.registrationNumber': '사업자번호(지출증빙용)',
  'consult.payment.virtual.registrationNumber.placeholder': '(-)없이 사업자번호를 입력해주세요',
  'consult.payment.virtual.confirm': '가상계좌 발급하기',
  'consult.payment.virtual.paidInfo.title': '가상계좌 발급',
  'consult.payment.virtual.paidInfo.title2': '가상계좌정보',
  'consult.payment.virtual.paidInfo.bank': '은행명',
  'consult.payment.virtual.paidInfo.accountNumber': '계좌번호',
  'consult.payment.virtual.paidInfo.price': '입금금액',
  'consult.payment.virtual.paidInfo.dueDate': '입금기한',
  'consult.constructStatus.DEFAULT': '상태',
  'order.history.status': '상태',
  'consult.constructStatus.CONSULTING': '상담중',
  'consult.constructStatus.WORKING': '시공진행중',
  'consult.constructStatus.COMPLETE': '시공완료',
  'consult.constructStatus.DUMMY': '수주보류',
  'consult.staff': '직원',
  'buyer.staff': '직원',
  'consult.sort.dateCreated': '최근 등록순',
  'consult.sort.dateUpdated': '최근 업데이트순',
  'consult.sort.dateLastConsult': '최근 상담순',
  'consult.checkList.title.residential.livingRoom.same': '거실과 동일한 자재 선택하기',
  'consult.chatView.placeholder': '메시지를 입력하세요',
  'consult.checkList.spaces.uncheck': '공간 선택 해제 시\n작성한 내용이 모두 삭제됩니다',
  'consult.checkList.commercial.spaces.uncheck': '해당 양식을 제외시\n작성한 내용이 모두 삭제됩니다',
  'consult.customerAccount': '고객계정',
  'consult.history': '미팅 내역',
  'consult.floorHeight.placeholder': '층고 높이 입력',
  'consult.area.placeholder': '평수 입력',
  'consult.area.unit.1': '평당',
  'consult.area.unit.2': '㎡',
  'consult.budget.placeholder': '예산을 작성해주세요',
  'consult.contents.delete': '제외',
  'consult.input.space.placeholder': '공간을 입력해주세요',
  'consult.commercial.contents': '상담내용',
  'consult.commercial.add.history': '+ 미팅 추가하기',
  'consult.change.order': '순서변경',
  'consult.change.order.clicked': '저장하기',
  'consult.verifications.emailRequired': '고객 이메일을 먼저 작성해주세요.',
  'consult.verifications.willSendMail': '고객에게 초대 메일을 보낼까요?',
  'consult.verifications.send': '이메일 보내기',
  'consult.verifications.sendComplete.title': '초대 메일을 보냈습니다.',
  'consult.verifications.sendComplete.content': '고객이 가입을 완료하면 알림을 보내드릴께요:)',
  'consult.verifications.joinCompleted': '고객이 회원가입을 완료하였습니다.',
  'consult.verifications.joinRequest': '고객에게 초대 메일을 이미 보냈습니다.',
  'consult.customer.consult.basicInfo.windowSashs': '창호',
  'consult.checkList.title.residential.windowSashs': '창호 시공을 선택해주세요',
  'step.consult.windowSashs': '창호 시공',
  'consult.design.download.text.REQUEST': '디자인팀에서 접수를 확인하고 있습니다.\n디자인 작업 시 질의 사항이 생긴 경우,\n고객님께 채팅을 통해 질문을 드릴 수 있어요.',
  'consult.design.download.text.WAITING_PAYMENT': '결제 확인이 완료되면 디자인팀에서 작업을 시작합니다.',
  'consult.design.download.text.WORKING_RESIDENTIAL': '작업 소요 기간은 영업일 기준 2~3일 소요됩니다.\n작업이 완료되면 앱 알림을 통해 알려드릴게요.',
  'consult.design.download.text.WORKING_COMMERCIAL': '작업 소요 기간은 별도로 문의해주세요.\n작업이 완료되면 앱 알림을 통해 알려드릴게요.',
  'sidebar.consult.customer': '상담노트',
  'popup.customer.create.success.title': '신규 고객 연결이 완료되었습니다\n바로 상담하시겠어요?',
  'popup.customer.delete.title': '고객정보를 삭제하겠습니까?\n삭제 시 복구가 불가능합니다',
  'popup.customer.detail.startConsult': '아직 상담한 내역이 없습니다.\n바로 상담하시겠어요?',
  'popup.customer.detailInfo.noty.title': '시공사 전용 페이지입니다',
  'popup.customer.detailInfo.noty.content': '고객님과 상담 후에 따로 작성해주세요',
  'popup.customer.request.complete': '의뢰 신청이 완료되었습니다',
  'popup.customer.checkList.complete.title': '의뢰 신청이 완료되었습니다',
  'popup.customer.checkList.complete.content': '고객님과 상담 잘 마치셨나요?\n작성한 정보를 한번 더 확인해보세요',
  'popup.customer.proposal.alert': '시공사전용 정보 입력 후\n디자인 의뢰가 가능합니다',
  'popup.customer.proposal.alert2': '상담정보 입력 후\n디자인 의뢰가 가능합니다',
  'popup.button.checkList.complete': '고객 카드로 이동',
  'popup.button.style.cancel': '다른 스타일 고르기',
  'step.order.drawing.select.space': '투시도 공간 선택',
  'step.order.drawing.confirm': '의뢰서 확인',
  'step.noty.drawing.title': '의뢰 시 주의사항',
  'step.noty.drawing.content': '같은 공간이더라도, 컷 수에\n따라 금액이 추가됩니다',
  'popup.noty.proposal.title': '디자인 제안서 예시',
  'step.noty.proposal.title': '디자인 제안서 구성',
  'step.noty.proposal.content': `• 공간 컨셉\n• 평면도\n• 3D 투시도 2컷\n• 마감재 리스트\n• 가구 및 위생기기 리스트`,
  'step.noty.button': '나야 디자인 사례보기 >',
  'step.consult.demolitions': '철거 여부',
  'step.consult.temporaryWorks': '가설 선택',
  'step.consult.spaceSizes': '평형 선택',
  'step.consult.spaces': '시공 공간',
  'step.consult.spaceSituations': '공간 상황',
  'step.consult.styles': '스타일',
  'step.consult.material': '자재 선택',
  'work.accountancy.drawing': '도면',
  'common.yes2': '네',
  'portfolio.preview': '미리보기',
  'common.preview': '미리보기',
  'popup.customer.create.address.error': '검색 결과가 없습니다.',
  'popup.customer.create.address.oldValue': '지',
  'popup.customer.create.address.oldValue2': '번',
  'popup.customer.create.address.newValue': '도로명',
  'popup.customer.detailInfo.noty.confirm': '네, 알고있습니다',
  'popup.payment.virtual.alert': '가상계좌 발급시 해당 건은 카드 결제가 불가능합니다\n가상계좌를 발급하시겠습니까?',
  'popup.payment.virtual.alert.yes': '발급하기',
  'popup.payment.virtual.button.copy': '계좌 복사',
  'popup.button.style.select': '선택하기',
  'fileUpload.labelFileProcessing': '업로드 중',
  'fileUpload.labelFileProcessingComplete': '업로드 완료',
  'fileUpload.labelTapToUndo': ' ',
  'fileUpload.labelMaxFileSizeExceeded': '파일 크기가 최대 용량을 초과합니다.',
  'fileUpload.labelMaxFileSize': '최대 용량은 {filesize} 입니다.',
  'fileUpload.labelFileTypeNotAllowed': '허용되지 않는 파일형식 입니다.',
  'fileUpload.fileValidateTypeLabelExpectedTypes': '허용되는 파일형식: {allTypes}',
  'fileUpload.mapType.image/*': '이미지',
  'common.error': '서버 통신에 실패했습니다.\n잠시 후 다시 시도해주세요',
  'common.addFile': '파일 추가',
  'common.file': '파일',
  'naya.designTeam': '나야 디자인/코디팀',
  'consult.customer.files.info2': '* 상담에 필요한 현장 사진이나 실측 도면을 넣어서 보관하세요\n',
  'select.all': '전체 선택',
  'common.empty.select': '미입력',
  'common.empty.text': '미작성',
  'common.empty.text.long': '작성된 내용이 없습니다',
  'consult.budget.prefix': '금',
  'consult.budget.suffix': '원정',
  'common.about': '약',
  'consult.add.title': '하루에 1개의 미팅내역을\n생성할 수 있습니다',
  'consult.add.content': '오늘 작성한 미팅을 진행해주세요',
  'consult.first.meeting': '1차 미팅내역',
  'consult.nth.meeting': '차 미팅내역',
  'consult.space.delete.title': '작성된 내용이 모두 삭제됩니다',
  'consult.commercial.save.title': '상담 내역 저장 완료',
  'consult.commercial.save.contents': '24시간 이내로 수정이 가능합니다.',
  'consult.order.commercial.drawing.noty.column.period': '공간 면적에 따라 추가비용 발생하여, 자세한 견적은\n신청 후 나야 디자인팀이 상담을 통해 알려드립니다',
  'consult.order.commercial.drawing.commercial.price': '견적 산출 중입니다',
  'field.go.consult': '상담노트',
  'consult.drawing.button.label': '+ 평면도 첨부하기',
  'consult.drawing.title.label': '디자인 의뢰서',
  'consult.drawing.title': '평면도 첨부하기',
  'consult.drawing.question.title': '그리기 예시 보기',
  'consult.drawing.question.text': '위 그림과 같이 원하는 레이아웃을 직접 그려주시면,\n더 빠르게 3D투시도를 받을 수 있습니다.',
  'consult.drawing.button.changeFile': '파일 변경',
  'consult.drawing.empty.text': '사이즈가 기재된 도면 이미지를 첨부해주세요\npng, jpg 첨부 가능',
  'consult.drawing.empty.button.text': '파일 가져오기',
  'consult.drawing.view.title': '뷰 그리기',
  'consult.drawing.view.pen': '펜',
  'consult.drawing.view.line': '선',
  'consult.drawing.furniture.title': '가구 그리기',
  'consult.drawing.furniture.circle': '원',
  'consult.drawing.furniture.rectangle': '네모',
  'consult.drawing.furniture.text': '텍스트',
  'consult.drawing.furniture.delete': '선택 삭제',
  'consult.drawing.furniture.text.guide': '텍스트를 입력해주세요',
  'consult.drawing.update.title': '평면도 수정하기',
  'consult.file.attachment': '파일 첨부하기',
  'consult.customer.consult.checkList.required': '수주지원컨설팅 신청 시 필수 항목',
  'consult.title.2': '상담 정보',
  'consult.order.commercial.drawing.noty.title': '안내',
  'consult.order.commercial.drawing.noty.content': '아래 계좌로 이체를 진행해주세요.',

  // order
  'sidebar.order': '자재주문',
  'order.message': '배송정보를 먼저 입력하면\n해당 자재 주문 내역이 보입니다',
  'order.message.1': '* 표시된 항목은 필수사항입니다',
  'order.select.address': '배송지(현장) 선택',
  'order.field.address': '배송지 주소',
  'order.field.new': '+ 새로운 배송지(현장)로 주문',
  'order.field.new.input': '새로운 배송지 입력',
  'field.dateConstruct': '공사일정',
  'common.dateLastOrder': '최근 주문일',
  'user.phoneNumber': '전화번호',
  'material.unit': '단위',
  'seller.material.unit': '단위',
  'common.unit': '단위',
  'common.amount': '수량',
  'payment.material.quantity': '수량',
  'material.refund.orders.quantity': '수량',
  'order.cancel.item.quantity': '수량',
  'order.return.item.quantity': '수량',
  'order.quantity': '수량',
  'material.priceSale': '판매단가',
  'common.number': '번호',
  'common.hour': '시',
  'common.minute': '분',
  'order.field.budget': '현장 투입 예정 자재',
  'order.add.other.material': '직접 자재 찾기',
  'order.add.material.message': '자재 이름을 검색하세요.',
  'order.category1': '자재 공종',
  'order.category2': '자재 상세 공종',
  'empty.data': '데이터가 없습니다.',
  'order.add.checkList.required': '필수 체크사항',
  'order.add.quantity.placeholder': '수량을 입력해주세요.',
  'order.add.isb2b.message': '상품 이미지 준비중입니다.\n상담하기로 문의해주세요.\n\nTel. 1644-4908',
  'order.add.button': '자재 추가하기',
  'order.add.checkList.required.message': '필수 체크사항을 입력해주세요.',
  'order.add.search.result': '검색 결과',
  'order.add.checkList.modify': '필수 체크사항 수정',
  'order.add.memo': '주문 요청사항',
  'order.add.memo.message': '예) 절단해주세요. 양중팀 연결해주세요.\n차량 높이 제한 / 1.4톤 이하로 해주세요',
  'order.add.address.placeholder': '배송지(현장)를 선택해주세요.',
  'order.add.address2.placeholder': '상세 주소를 입력해주세요',
  'order.add.name.placeholder': '인수자 성명을 입력해주세요.',
  'order.add.phone.placeholder': '전화번호를 입력해주세요.',
  'order.add.button.select': '담기',
  'order.add.button.selected': '담기 완료',
  'order.add.button.add': '발주 요청',
  'order.add.total.1.1': '총 ',
  'order.add.total.1.2': ' 개의 자재 발주',
  'order.add.total.2.1': '주문 합계 : ',
  'order.add.total.2.2': ' (VAT 별도)',
  'order.add.total.3.1': '결제 금액 : ',
  'order.add.total.3.2': ' (VAT 포함)',
  'order.add.total.4': '배송비는 납품처에서 발주서 확인후 입력됩니다.',
  ORDER_ERROR_ADDRESS: '주소를 입력해주세요.',
  ORDER_ERROR_ADDRESS2: '상세 주소를 입력해주세요.',
  ORDER_ERROR_LATITUDE: '주소에 오류가 있습니다.\n주소 검색을 다시 진행해주세요.',
  ORDER_ERROR_LONGITUDE: '주소에 오류가 있습니다.\n주소 검색을 다시 진행해주세요.',
  ORDER_ERROR_RECIPIENTS: '인수자 정보를 확인해주세요.',
  ORDER_ERROR_DATE_REQUIRED_DELIVERY: '희망 도착 일시를 확인해주세요.',
  ORDER_ERROR_ORDER: '발주 요청된 자재가 없습니다.\n자재 수량을 확인해주세요.',
  POPUP_ORDER_MESSAGE: '판매자가 발주서를 검토 중이며, 재고 및 배송비가 확인되면 결제 알림을 앱으로 보내드립니다.',
  POPUP_ORDER_TITLE: '발주 요청 완료',
  'order.add.material.info': '자재 정보',
  'order.category.filter': '카테고리 필터',
  'order.autoCart': '특가마감재',
  'material.option.origin': '원산지',
  'material.option.thickness': '두께',
  'material.option.standard': '규격',
  'material.option.type': '타입',
  'material.option.pcsBox': 'PCS/BOX',
  'material.option.m2Box': 'M2/BOX',
  'material.option.luminosity': '광도',
  'material.option.applicationArea': '적용부위',
  'material.option.brand': '브랜드명',
  'material.option.information': '종합설명',
  'material.option.color': '색상',
  'material.option.modelNumber': '모델품번',
  'material.option.flameRetardant': '방염여부',
  'material.option.certification': '인증서 유무',
  'material.option.part': '부속폼 정보',
  'material.option.rawMaterial': '소재',
  'order.budget.over.message': '예산 초과된 {num}개 상품이 있어요',
  'order.budget.over.message.2': '관리자에게 해당 자재 예산 추가요청할까요?',
  'button.request': '요청하기',
  'order.budget.request.title': '예산 추가 요청',
  'order.budget.request.quantity': '요청 수량',
  'order.budget.request.memo': '추가 사유',
  'order.budget.request.memo.placeholder': '추가 사유를 입력하세요',
  'order.budget.request.confirm': '예산 추가 요청 완료',
  'order.budget.request.confirm.content': '관리자에게 요청 알림이 발송되었습니다\n예산 수정 후에 발주가 가능합니다',
  'order.budget.quantity': '예산수량',

  // field/log-detail
  'partner.update': '변경',
  'title.field.workLog': '공사일보',
  'field.log.detail': '공사일보',
  'field.title.log.detail': '공사일보',
  'dashboard.field.log': '공사일보',
  'field.workLog.detail.1': '결재/확인',
  'field.workLog.detail.3': '작성일자',
  'field.minutesOfMeetings.date.writing': '작성일자',
  'field.workLog.detail.4': '날씨',
  'field.workLog.detail.5': '공구명',
  'field.workLog.detail.6': '공사기간',
  'field.workLog.detail.8': '금일 주요 작업',
  'field.workLog.detail.9': '내일 주요 예정 작업',
  'field.workLog.detail.10': '공사 내용 및 진행률',
  'field.workLog.detail.11': '인원 투입 현황',
  'field.workLog.detail.12': '공종',
  'field.workLog.detail.13': '계약 대비\n비율(보할)',
  'field.workLog.detail.14': '직전누계\n진행비율',
  'field.workLog.detail.15': '금일\n진행비율',
  'field.workLog.detail.16': '공사누계\n진행률',
  'field.workLog.detail.17': '직종',
  'field.workLog.detail.18': '주간',
  'field.workLog.detail.19': '야간',
  'field.workLog.detail.20': '직전 누계',
  'field.workLog.detail.21': '금일',
  'field.workLog.detail.22': '총누계',
  'field.workLog.detail.23': '장비 투입 현황',
  'field.workLog.detail.24': '단위(규격)',
  'field.workLog.detail.25': '직전 누계',
  'field.workLog.detail.26': '금일 수량',
  'field.workLog.detail.27': '총 누계',
  'field.workLog.detail.28': '주요 자재 투입 현황',
  'field.workLog.detail.29': 'Note',
  'field.workLog.detail.30': '진행률 합계',
  'field.workLog.detail.31': '공유하기 (작업일보/사진)',
  'field.workLog.detail.33': '작업내용 저장하기',
  'message.save': '저장되었습니다.',
  'field.workLog.detail.34': '나야에서 불러오기',
  'field.workLog.detail.34.messages':
    '자재 목록은 해당 현장 내에서 주문한 건 중 배송 중이거나 배송 완료된 건만 조회됩니다.\n다른 일자에서 사용한 주문 건은 다시 선택할 수 없습니다.(현장 일보에 한번만 등록가능)',
  'field.workLog.detail.workLogDetailWV.update': '보할 변경',
  'field.workLog.detail.filter.date': '일자 검색',
  'field.workLog.detail.35': '담당(작성자)',
  'common.download': '다운로드',
  'button.updatable.true': '수정 가능',
  'button.updatable.false': '수정 불가',
  'button.updatable': '수정 불가 처리',
  'message.workLog.confirm': '수정불가 처리시 본 작성일자 포함 이전 일보들은 추가, 수정, 삭제 할 수 없습니다.\n수정불가 처리하시겠습니까?',
  'error.worklogDetail.empty': '작성일자, 날씨, 공구명, 금일 주요 작업, 내일 주요 예정 작업은 필수 항목입니다.',
  'error.INVALID_DATE': '수정불가처리 이전 날짜는 선택할 수 없습니다.',
  'common.download.image': '이미지 다운로드',
  'common.download.pdf': 'PDF 다운로드',

  // field/minutes-of-meetings
  'popup.confirm': '완료하시겠습니까?',
  'order.material.etc': '외',
  'unit.countNumber': '개',
  'field.title.minutesOfMeetings': '상담일지',
  'field.minutesOfMeetings.new': '+ 새 상담일지 작성하기',
  'common.document': '문서',
  'common.people.number': '인',
  'field.minutesOfMeetings.title': '회의제목',
  'field.minutesOfMeetings.participant': '참석자',
  'field.minutesOfMeetings.date': '회의일자',
  'field.minutesOfMeetings.date.dateMeeting': '날짜순',
  'field.minutesOfMeetings.theme': '회의주제',
  'field.minutesOfMeetings.title.create': '새 상담일지',
  'common.write.confirm': '작성완료',
  'contents.title': '제목',
  'common.write.placeholder': '제목을 입력해주세요',
  'field.minutesOfMeetings.desc': '회의주제(선택)',
  'field.minutesOfMeetings.desc.placeholder': '회의 주제를 입력해주세요',
  'memo.placeholder': '메모하고 싶은 내용을 자유롭게 적어보세요',
  'field.minutesOfMeetings.participants.placeholders': '회의 참석자 선택하기',
  'common.input.custom': '직접입력',
  'field.minutesOfMeetings.title.update': '상담일지 수정',
  'field.minutesOfMeetings.list.empty1': '작성된 상담일지가 없습니다',
  'field.minutesOfMeetings.list.empty2': '새 상담일지 작성하기 >',
  'field.minutesOfMeetings.create.cancel.popup.title': '작성한 상담일지를 저장하지 않고\n나가시겠어요?',
  'field.minutesOfMeetings.create.cancel.popup.confirm': '네, 나갈게요',
  'field.minutesOfMeetings.create.confirm.popup.title': '작성 완료',
  'field.minutesOfMeetings.create.confirm.popup.content': '최초 작성 이후 24시간 이내로\n수정 가능합니다',

  // recruitment
  'common.notIpAreaText': 'IP 불가 지역',
  'recruitment.join.required': '1. 필수 입력',
  'recruitment.join.options': '2. 선택 입력',
  'common.businessOwner': '대표자명',
  'recruitment.join.title': '나야 시공팀찾기 멤버가입',
  'common.multiSelect.possible': '복수선택 가능',
  'recruitment.majorClients': '주요거래처',
  'recruitment.majorClients.placeholder': '입력후 엔터를 눌러주세요',
  'recruitment.dateEstablishment': '설립일',
  'recruitment.dateEstablishment.placeholder': '설립일 선택',
  'recruitment.numOfEmployee.placeholder': '직원수 선택',
  'recruitment.constructionExperience.placeholder': '시공경력 선택',
  'recruitment.imageBusinessRegistration': '사업자등록증',
  'common.fileUpload.text': '파일 업로드',
  'common.fileUpload.subText': '(jpeg, png, pdf 3mb 이하)',
  'recruitment.managerPhone': '담당자 번호',
  'recruitment.managerPhone.placeholder': '담당자 번호 (-)제외',
  'recruitment.businessPhone': '회사 전화번호',
  'recruitment.businessPhone.placeholder': '회사 전화번호 (-)제외',
  'recruitment.phone.placeholder': '사업자번호(-)제외',
  'recruitment.user.name': '{user} 님',
  'recruitment.address2': '상세주소',
  'footer.body':
    '주식회사 씨투와이 | 대표이사: 문준철\n전화번호: (국번없이)1644-4908\n주소: 서울특별시 마포구 백범로31길 21, 714호 (공덕동, 서울창업허브본관)\n사업자등록번호: 896-81-01068\n계좌번호: 우리은행 1005-904-657215 | KB국민은행 827901-04-135256',
  'footer.footer.left.1': '개인정보처리방침',
  'footer.footer.left.2': '이용약관',
  'footer.footer.left.3': '전자금융거래이용약관',
  'footer.footer.left.4': '고객센터',
  'footer.footer.right': 'ⓒC2Y INC. ALL RIGHT RESERVED',
  'recruitment.capitalStock': '자본금',
  'recruitment.introduce': '회사소개글',
  'recruitment.introduce.placeholder': '직접 작성해주세요',
  'recruitment.doc': '면허 및 증빙자료',
  'recruitment.doc.placeholder': '파일구분 입력',
  'recruitment.doc.errText': '파일구분명을 입력해주세요',
  'recruitment.doc.subtext': '면허, 국세완납증명서, 전년도 재무제표, 신용평가등급확인, 표창장, 감사패 자료 등',
  'recruitment.companyHistories': '회사연혁',
  'recruitment.companyHistories.button': '+ 연혁 추가하기',
  'recruitment.companyHistories.content.placeholder': '내용 입력',
  'recruitment.companyHistories.date.placeholder': '연혁 일자 선택',
  'recruitment.companyHistories.memo': '비고(선택)',
  'recruitment.companyHistories.memo.placeholder': '비고',
  'recruitment.portfolios': '시공실적',
  'recruitment.portfolios.button': '+ 시공실적 추가하기',
  'recruitment.portfolios.images': '시공사진',
  'recruitment.portfolios.fieldName.placeholder': '현장명 입력',
  'recruitment.portfolios.client': '발주처',
  'recruitment.portfolios.client.placeholder': '발주처 입력',
  'recruitment.portfolios.dateStart.placeholder': '시작 일 선택',
  'recruitment.portfolios.dateEnd.placeholder': '종료 일 선택',
  'recruitment.policy.title': '개인정보 처리 관한 동의',
  'recruitment.policy.1': '개인정보 수집 및 이용 동의 (필수)',
  'recruitment.join': '가입하기',
  'recruitment.join.error.empty': '항목을 모두 입력해주세요',
  'recruitment.join.error.invalidPassword': '비밀번호를 8 ~ 12 글자로 입력해주세요',
  'recruitment.join.error.isNotSamePassword': '비밀번호가 서로 다릅니다',
  'recruitment.join.error.agreePrivacyUsage': '개인정보 수집 및 이용 동의는 필수항목입니다',
  'recruitment.join.confirm': '가입되었습니다',
  'err.recruitment.email': '이메일을 입력해주세요',
  'err.recruitment.businessOwner': '대표자명을 입력해주세요',
  'err.recruitment.imageBusinessRegistration': '사업자등록증을 업로드해주세요',
  'err.recruitment.dateEstablishment': '설립일을 선택해주세요',
  'err.recruitment.dateEstablishment.2': '날짜 형식을 확인해주세요(설립일)',
  'err.recruitment.numOfEmployee': '직원수를 선택해주세요',
  'err.recruitment.constructionExperience': '시공경력을 선택해주세요',
  'err.recruitment.companyName': '회사명을 입력해주세요',
  'err.recruitment.typeOfWorks': '주력 공종을 선택해주세요',
  'err.recruitment.constructionSpaceTypes': '주력시공공간을 선택해주세요',
  'err.recruitment.constructionAreas': '시공지역을 선택해주세요',
  'err.recruitment.companyHistories': '회사연혁을 확인해주세요\n내용,일자는 필수항목입니다',
  'err.recruitment.portfolios': '시공실적을 확인해주세요\n현장명,발주처,일자는 필수항목입니다',
  'recruitment.constructionAreas.all': '전국',
  'recruitment.list.guide': '상단에 있는 영역이 최신순입니다',
  'common.autoSave': '저장중...',
  'recruitment.referral': '추천인(선택)',
  'recruitment.referral.placeholder': '상호명 혹은 단체이름',
  'recruitment.go.ERP': '나야 ERP로 이동',
  'recruitment.businessType': '회사형태',
  'recruitment.businessType.placeholder': '회사형태 선택',
  'err.recruitment.businessType': '회사형태를 선택해주세요',
  'recruitment.logo': '로고',

  // transaction
  'search.material.category.0': '카테고리1',
  'search.material.category.1': '카테고리2',
  'transactions.date': '거래일시',
  'transactions.vat': '부가세',
  'transactions.etc': '비고',
  'transactions.supply.price': '공급가액',
  'transactions.startEnd': '거래기간',
  'transactions.sum': '합계금액',
  'transactions.document': '거래명세서',
  'payment.MATERIAL_PAYMENT_COMPANY.CHAI_PORT': '차이포트',
  'sidebar.transaction.transactions': '거래명세표',
  'autocomplete.noOptions': '결과가 없습니다',
  'transactions.deliveryConfirm': '납품확인서',
  'translate.title.info': '거래가 최종 완료된 내역만 표기됩니다.',
  'translate.deliveryConfirm.info.1': '납품확인서 출력',
  'translate.deliveryConfirm.info.2': '의 경우,\n',
  'translate.deliveryConfirm.info.3': '주문취소된 건',
  'translate.deliveryConfirm.info.4': '은 항목에서 제외됩니다\n',
  'translate.deliveryConfirm.info.5': '반품건',
  'translate.deliveryConfirm.info.6': '은 수량에서 마이너스로 표시됩니다',
  'export.transactions': '거래명세서 출력',
  'export.transactions.deliveryConfirm': '납품확인서 출력',
  'transaction.filter.keyword.placeholder': '상품명, 옵션명으로 검색해보세요',

  // transaction/order
  'payment.info': '결제 정보',
  'material.order.number': '주문번호',
  'search.code': '주문번호',
  'sidebar.material.order': '발주내역',
  'sidebar.material.order.detail': '주문 상세',
  'search.field': '현장',
  'order.field.name': '현장',
  'buyer.field': '현장',
  'order.material.etcCount': '건',
  'order.status': '주문 상태',
  'order.status.BIDDING': '입찰 중',
  'order.status.BIDDING_COMPLETE': '입찰 마감',
  'order.status.PAYMENT_CONFIRMING': '결제 중',
  'order.status.READY': '배송 준비',
  'order.status.DELIVERING': '배송 중',
  'order.status.DELIVERY_COMPLETE': '배송 완료',
  'order.status.CONFIRMED': '인수 확인',
  'order.status.REFUND': '환불',
  'order.status.CANCEL': '주문 취소',
  'order.ahaMoveInfo': '배송 정보',
  'selfDelivery.delivery.status.READY': '배송 준비',
  'selfDelivery.delivery.status.IN_TRANSIT': '배송 중',
  'selfDelivery.delivery.status.DELIVERED': '배송 완료',
  'ahaMoves.delivery.status.IDLE': '주문 완료',
  'ahaMoves.delivery.status.ASSIGNING': '배송기사 찾는 중',
  'ahaMoves.delivery.status.ACCEPTED': '배정 완료',
  'ahaMoves.delivery.status.IN_PROCESS': '적재 완료',
  'ahaMoves.delivery.status.COMPLETED': '배송 완료',
  'ahaMoves.delivery.status.CANCELLED': '배송 취소',
  'material.info': '상품 정보',
  'payment.logiSpot.carType.0': '오토바이',
  'payment.logiSpot.carType.1': '다마스',
  'payment.logiSpot.carType.2': '라보',
  'payment.logiSpot.carType.3': '카고/윙',
  'payment.logiSpot.carType.4': '카고',
  'payment.logiSpot.carType.5': '윙바디',
  'payment.logiSpot.carType.6': '탑',
  'payment.logiSpot.carType.7': '냉동',
  'payment.logiSpot.carType.8': '냉장',
  'payment.logiSpot.carType.10': '트레일러',
  'payment.logiSpot.carType.11': '컨테이너',
  'payment.logiSpot.carType.12': '방통차',
  'payment.logiSpot.carType.13': '사다리차',
  'payment.logiSpot.carType.14': '지게차',
  'payment.logiSpot.carTon.0.3': '0.3톤',
  'payment.logiSpot.carTon.0.5': '0.5톤',
  'payment.logiSpot.carTon.1': '1톤',
  'payment.logiSpot.carTon.1.4': '1.2톤',
  'payment.logiSpot.carTon.2.5': '2.5톤',
  'payment.logiSpot.carTon.3.5': '3.5톤',
  'payment.logiSpot.carTon.5': '5톤',
  'payment.logiSpot.carTon.5P': '5톤플러스',
  'payment.logiSpot.carTon.5W': '5톤축',
  'payment.logiSpot.carTon.11': '11톤',
  'payment.logiSpot.carTon.11W': '11톤축',
  'payment.logiSpot.carTon.18': '18톤',
  'payment.logiSpot.carTon.25': '25톤',
  'payment.logiSpot.carTon.20FT': '20피트',
  'payment.logiSpot.carTon.40FT': '40피트',
  'payment.logiSpot.carTon.1LAD': '1톤(최대8층)',
  'payment.logiSpot.carTon.2.5LAD': '2.5톤(최대13층)',
  'payment.logiSpot.carTon.3.5LAD': '3.5톤(최대16층)',
  'payment.logiSpot.carTon.5LAD': '5톤(최대 25층)',
  'payment.logiSpot.carTon.6LAD': '6톤(최대 25층)',
  'payment.logiSpot.carTon.7.5LAD': '7.5톤(최대 25층)',
  'payment.logiSpot.carTon.10LAD': '10톤(최대 25층)',
  'payment.logiSpot.carTon.FORKLIFT': '지게차',
  'delivery.logiSpot.status.ASSIGNING': '배송기사 찾는 중',
  'delivery.logiSpot.status.ACCEPTED': '배차완료',
  'delivery.logiSpot.status.LOAD_COMPLETE': '상차완료',
  'delivery.logiSpot.status.UNLOAD_COMPLETE': '하차완료',
  'delivery.logiSpot.status.REQUEST_CANCEL': '취소요청',
  'delivery.logiSpot.status.REQUEST_MODIFY': '수정요청',
  'payment.MATERIAL_PAYMENT_METHOD.CREDIT': '외상',
  'payment.MATERIAL_PAYMENT_METHOD.TRANSFER': '계좌이체',
  'payment.MATERIAL_PAYMENT_METHOD.CARD_AUTO': '카드 자동 결제',
  'payment.MATERIAL_PAYMENT_METHOD.VIRTUAL_ACCOUNT': '가상 계좌',
  'payment.MATERIAL_PAYMENT_METHOD.REAL_TIME_TRANSFER': '실시간 계좌이체',
  'payment.MATERIAL_PAYMENT_COMPANY.SELF': '직접거래',
  'payment.MATERIAL_PAYMENT_COMPANY.TOSS': '토스페이먼츠',
  'payment.datePaid': '결제일',
  'common.sum': '합계',
  'delivery.sum': '합계',
  'order.isImmediateDelivery': '즉시배송',
  'order.isImmediateDelivery.false': '예약배송',
  'sidebar.material.refund.cancel': '주문취소',
  'sidebar.material.refund.return': '반품',
  'material.refund.dateCreated': '주문일',
  'material.refund.orders.material': '상품',
  'order.history.type.material': '상품',
  'order.cancel.item.item': '상품',
  'order.return.item.item': '상품',
  'material.refund.delivery.type.SELF_DELIVERY': '자체배송',
  'material.refund.delivery.type.LOGI_SPOT': '로지스팟',
  'material.refund.delivery.type.AHA_MOVES': 'AhaMoves',
  'material.order.payment.isPaid': '결제여부',
  'material.order.item': '항목',
  'order.cancel.item': '항목',
  'order.return.item': '항목',
  'material.order.price': '단가',
  'order.cancel.item.amount': '단가',
  'order.return.item.amount': '단가',
  'material.delivery.recipients': '인수자(최대 3명)',
  'material.delivery.dateRequiredDelivery': '납품요청일',
  'material.payment.amountMaterials': '상품합계',
  'material.payment.amountDeliverys': '배송비합계',
  'MATERIAL_RETURN_STATUS.REQUEST': '반품 접수',
  'MATERIAL_RETURN_STATUS.RETURNING': '반품 회수중',
  'MATERIAL_RETURN_STATUS.COMPLETE': '반품 완료',
  'MATERIAL_RETURN_STATUS.REJECT': '반려',
  'return.deliveryMethod': '반품배송방법',
  'return.charger': '과실',
  'MATERIAL_RETURN_CHARGER.BUYER': '구매자',
  'MATERIAL_RETURN_CHARGER.SELLER': '판매자',
  'MATERIAL_RETURN_CHARGER.DELIVERY_COMPANY': '배송업체',
  'MATERIAL_RETURN_REASON.BUYER_1': '단순변심(구매자과실)',
  'MATERIAL_RETURN_REASON.SELLER_1': '불량(판매자과실)',
  'MATERIAL_RETURN_REASON.SELLER_2': '오배송(판매자과실)',
  'MATERIAL_RETURN_REASON.SELLER_3': '자체배송 파손(판매자과실)',
  'MATERIAL_RETURN_DELIVERY_METHOD.NAYA': '나야 배송',
  'MATERIAL_RETURN_DELIVERY_METHOD.BUYER': '구매자 자체 배송',
  'MATERIAL_RETURN_DELIVERY_METHOD.SELLER': '판매자 자체 배송',
  'MATERIAL_RETURN_DELIVERY_METHOD.DROP': '폐기',
  'payment.logiSpot.carTon.MOTO': '오토바이',
  'order.history': '주문내역',
  'MATERIAL_ORDER_STATUS.READY_REGISTRATE': '재고확인 중',
  'MATERIAL_ORDER_STATUS.BIDDING': '재고확인 중',
  'MATERIAL_ORDER_STATUS.PAYMENT_CONFIRMING': '결제 중',
  'MATERIAL_ORDER_STATUS.DELIVERING': '배송 중',
  'MATERIAL_ORDER_STATUS.CANCEL': '주문 취소',
  'MATERIAL_ORDER_STATUS.RETURN': '반품',
  'MATERIAL_ORDER_STATUS.BIDDING.SELLER': '판매자 재고확인 중',
  'MATERIAL_ORDER_STATUS.BIDDING.BUYER': '구매자 견적확인 중',
  'common.totalSum': '총 합계',
  'MATERIAL_DELIVERY_STATUS.READY': '배송 준비',
  'MATERIAL_DELIVERY_STATUS.DELIVERING': '배송 중',
  'MATERIAL_DELIVERY_STATUS.CONFIRMED': '배송 완료',
  'payment.MATERIAL_PAYMENT_METHOD.CARD': '카드 결제',
  'delivery.logiSpot.status.BEFORE': '배차 전',
  'order.info': '주문 상세',
  'material.refund.cancel.history': '결제 후 주문취소에 대한 환불내역',
  'material.refund.return.history': '반품에 대한 환불내역',
  'order.history.inspector': '인수자',
  'order.history.type.delivery': '배송',
  'order.history.type.otherCosts': '환불배송비(기타)',
  'order.cancel.staff': '취소 요청자',
  'order.cancel.dateCreated': '취소 요청일',
  'order.cancel.refundAmount': '환불 금액',
  'order.return.refundAmount': '환불 금액',
  'order.cancel.result': '환불 처리 결과',
  'order.return.result': '환불 처리 결과',
  'order.cancel.result.method': '환불방법',
  'order.return.result.method': '환불방법',
  'order.cancel.result.date': '환불일자',
  'order.return.result.date': '환불일자',
  'order.cancel.result.date.notYet': '환불 진행중',
  'order.return.staff': '환불 요청자',
  'order.return.dateRequired': '환불 요청일',
  'order.return.status': '반품상황',
  'order.return.reason': '사유',
  'order.return.detailReason': '상세 사유',
  'order.return.address': '구매자\n반품 주소',
  'order.return.deliveryMethod': '반품배송방법',
  'order.return.charger': '과실',
  'order.return.item.deliveryStatus': '배송상황',
  'order.return.item.delivery.SELF_DELIVERY': '판매자 자체배송',
  'order.return.item.delivery.LOGI_SPOT': '로지스팟 배송',
  'order.return.item.delivery.AHA_MOVES': 'AhaMoves',
  'material.refund.delivery.type.SELLER_DELIVERY': '판매자 자체배송',
  'transactions.otherCosts': '기타비용',
  'delivery.unit': '대',
  'transactions.date.now': '이번달',
  'transactions.export': '출력하기',
  'field.workLog.detail.32': '출력하기',
  'MATERIAL_ORDER_STATUS.DELIVERY_COMPLETE': '거래(인수 완료)',
  'transactions.date.prev': '지난달',
  'material.order.list.item': '항목(단위 원, 부가세 포함)',
  'MATERIAL_RETURN_REASON.DELIVERY_1': '배송 불만(배송업체과실)',
  'MATERIAL_RETURN_REASON.NAYA_1': '전산오류(나야과실)',
  'MATERIAL_RETURN_CHARGER.NAYA': '나야',
  'common.discounts': '할인',
  'order.discounts.FLOOR': '단수정리',
  'sum.discounts': '할인합계',
  'order.top.message2': '[바로가기]',
  'sidebar.transaction.order': '실시간 주문 내역',
  'order.top.message1': '거래가 완료된 금액은 거래명세표를 확인하세요. ',
  'order.price.vat': '단가(VAT 별도)',
  'common.sum.vat': '합계(부가세 포함)',
  'button.add.update': '추가/수정',
  'common.options': '옵션',
  'order.recipients.name': '인수자 성명',
  'order.dateRequiredDelivery': '희망 도착 일시',
  'select.option.message': '옵션을 선택해 주세요.',
  'dashboard.right.1': '(단위: 원)',
  'order.list.checkList': '체크사항',
  'order.confirm.title': '발주요청 완료',
  'order.confirm.message1': '재고 여부와 배송비가 확인되면\n결제 알람을 드립니다',
  'order.confirm.message2': '나야 앱을 설치해주세요',
  'order.confirm.yes': '설치하러 가기',
  'order.inquiry.message1': '투입 예정 자재 접수',
  'order.inquiry.message2': '직접 일일이 구매 자재를 찾지 마세요!\n현장 투입 예정 자재 리스트(계약 내역서 등) 사진을 주시면\n여기에 저희가 업로드 해드려요 (당일 불가)',
  'button.uploadFile': '파일 업로드',
  'order.inquiry.title': '투입 예정 자재 접수',
  'button.sendPhoto': '사진 보내기',
  'order.inquiry.complete': '전송 완료',
  'order.inquiry.message': '업로드 완료 시 발주가 가능합니다\n완료되면 알림으로 알려드릴게요',
  'order.estimate.price': '특별견적가',
  'transaction.order.detail.button.virtualAccount': '무통장입금',
  'transaction.order.detail.button.card': '카드결제',
  'transaction.order.detail.button.credit': '외상거래',
  'transaction.order.detail.popup.payment.before.title': '결제 전 알림',
  'transaction.order.detail.popup.payment.before.contents':
    '결제 이후에는 발주 취소가 불가하기에 입금 전 발주서를 다시 확인하시기를 부탁드립니다.\n\n* 결제 완료 후 납품 일자에 맞춰서 배송이 진행됩니다.\n\n결제를 진행하시겠습니까?',
  'transaction.order.detail.popup.payment.before.customer.name': '입금자명을 입력해주세요',
  'transaction.order.detail.popup.payment.before.registration.number': '(-)없이 사업자번호를 입력해주세요',
  'transaction.order.detail.popup.payment.before.customer.email': '결제 정보 받을 이메일을 입력해주세요',
  'transaction.order.detail.popup.payment.before.bank': '은행 선택',
  'transaction.order.detail.popup.payment.credit.title': '외상으로 결제하시겠어요?',
  'transaction.order.detail.popup.payment.credit.available': '외상 한도 잔액',
  'transaction.order.detail.popup.payment.credit.expected': '결제 예정금액',
  'transaction.order.detail.popup.payment.credit.remains': '결제 후 외상한도잔액',
  'transaction.order.detail.popup.payment.complete': '결제가 완료되었습니다.',
  'transaction.order.detail.popup.payment.complete.error': '결제에 실패하였습니다. 잠시 후 다시 시도해주세요.',
  'transaction.order.detail.popup.payment.virtual.account.customer.name': '입금자명',
  'transaction.order.detail.popup.payment.virtual.account.bank': '입금계좌 은행',
  'transaction.order.detail.popup.payment.virtual.account.registration.number': '사업자(지출증빙)',
  'transaction.order.detail.popup.payment.virtual.account.button': '가상계좌 발급하기',
  'transaction.order.detail.popup.payment.virtual.account.bank.required': '은행을 선택해주세요',
  'transaction.order.detail.popup.payment.virtual.account.customer.name.required': '입금자명을 입력해주세요',
  'transaction.order.detail.popup.payment.virtual.account.registration.number.required': '사업자(지출증빙)를 입력해주세요',
  'transaction.order.detail.popup.payment.virtual.account.complete.title': '가상계좌 결제 안내',
  'search.statuses': '상태(중복선택)',
  'order.tracking.number.update.trackingNumber': '송장번호',

  // field/budget
  'material.category0.name': '카테고리1',
  'material.category1.name': '카테고리2',
  'material.category4.name': '상품명',
  'material.no': '상품코드',
  'seller.material.name': '상품명',
  'common.budget': '예산',
  'buyer.field.budget': '예산',
  'add.budget': '예산 추가',
  'b2c.material.keywords': '키워드',
  'buyer.field.budget.update': '예산 수정',
  'buyer.quantityRequired.total': '총 실행예산수량',
  'search.material': '자재 추가',
  'buyer.field.budget.add': '예산 입력',
  'error.duplicate': '중복된 항목이 존재합니다.',
  'common.required': '필수입력사항 입니다.',
  'budget.date.no': '희망일자없음',
  'button.add.quantity.date': '일자 / 수량 추가',
  'buyer.field.budget.date': '발주알림 희망일자',
  'buyer.field.budget.date.option': '발주알림 희망일자(선택 사항)',
  'buyer.field.budget.quantity': '일자별 수량',
  'common.memo.option': '메모(선택사항)',
  'field.buyed': '구매',
  'field.amountRequired': '금액\n(기준단가)',
  'field.budget.delete.group': '예산 일괄 삭제',
  'field.budget.delete': '예산 삭제',
  'field.title.budget': '예산관리',
  'field.budget.request.list': '예산 요청 목록 보기',
  'field.budget.request': '예산 요청',
  'field.budget.request.info': '요청인 정보',
  'field.budget.request.info.name': '요청인 성함',
  'field.budget.request.info.date': '요청일',
  'field.budget.request.material': '예산 요청 자재',
  'field.budget.request.list.more': '외 {num}건',
  'field.budget.empty': '예산없음',

  // calendar
  'button.save': '저장',
  'calendar.prev': '지난 달',
  'calendar.now': '현재',
  'calendar.next': '다음 달',
  'common.year': '년',
  'common.month': '월',
  'calendar.budget': '발주알림희망일자',
  'calendar.budget.time': '08:00',
  'calendar.budget.setting': '발주알림희망일자 관리',
  'calendar.budget.add': '발주알림희망일자 추가',
  'field.schedule.isNoty': '알림 여부',
  'field.schedule.noty': '푸시 알림',
  'calendar.message.2': '오전 8:00 에 앱으로\n푸시 알림이 갑니다',
  'sidebar.material.order.calendar': '일정',
  'calendar.plan': '일정 메모',
  'calendar.delivery.date': '납품 확정',
  'calendar.order': '결제 대기',
  'calendar.plan.add': '일정 및 알림 설정',
  'calendar.field.placeholder': '현장 선택',
  'calendar.message.1': '일정과 알림을 설정하시면 앱으로\n해당 일시에 스케줄 알림을 드립니다',

  // dashboard
  'transactions.material': '품목',
  'dashboard.field.order': '자재주문',
  'dashboard.field.contract': '전자계약',
  'dashboard.field.budget': '예산관리',
  'dashboard.field.meeting': '상담일지',
  'dashboard.field.item': '품목별 거래내역',
  'dashboard.field.budget.setting': '예산수량 설정',
  'dashboard.field.transaction': '거래명세표 확인/출력',
  'common.rank': '순위',
  'dashboard.field.order.quantity': '발주수량',
  'dashboard.field.budget.quantity': '예산수량',
  'dashboard.field.average.amount': '평균단가',
  'dashboard.field.order.material.empty': '거래내역이 없습니다.',
  'dashboard.field.order.material.empty.link': '자재 발주하기 >',

  // setting
  'buyer.favorite': '즐겨찾기',
  'buyer.favorite.quantityCompleted': '실행완료수량',
  'favorite.add.update': '즐겨찾기 추가/수정',
  'title.field.subFields': '협력업체',
  'field.surField': '발주처',
  'favorite.manage': '즐겨찾기 관리',

  // field/contract
  'field.contract': '전자계약',
  'field.contract.label.constructionInfo.name': '공사명을 입력해주세요',
  'field.contract.label.constructionInfo.address': '공사 장소를 입력해주세요',
  'field.contract.label.constructionInfo.dateStart': '착공일자를 선택해주세요',
  'field.contract.label.constructionInfo.dateEnd': '준공일자를 선택해주세요',
  'field.contract.label.contractAmount.supply': '공급가액을 입력해주세요',
  'field.contract.label.contractAmount.memoTotal': '총공사 금액 비고를 작성해주세요',
  'field.contract.label.contractAmount.memoSupply': '공급가액 비고를 작성해주세요',
  'field.contract.label.contractAmount.memoVat': '부가세 비고를 작성해주세요',
  'field.contract.label.payment.advance': '선급금을 입력해주세요',
  'field.contract.label.payment.interim1st': '1차 중도금을 입력해주세요',
  'field.contract.label.payment.dueDays1st': '1차 중도금 지급조건을 입력해주세요',
  'field.contract.label.payment.interim2st': '2차 중도금을 입력해주세요',
  'field.contract.label.payment.dueDays2st': '2차 중도금 지급조건을 입력해주세요',
  'field.contract.label.defects.yearsOfLiability': '하자담보책임기간을 입력해주세요',
  'field.contract.label.defects.rateOfRepairDeposit': '하자보수보증금율을 입력해주세요',
  'field.contract.label.defects.rateOfLiquidation': '지체상금율을 입력해주세요',
  'field.contract.label.contractInfo': '계약일을 선택해주세요',
  'field.contract.label.contractInfo.contractor.name': '고객 성명을 입력해주세요',
  'field.contract.label.contractInfo.contractor.contact': '고객 연락처를 작성해주세요',
  'field.contract.label.contractInfo.contractor.address': '고객 주소를 입력해주세요',
  'field.contract.label.contractInfo.recipient.name': '대표자명을 입력해주세요',
  'field.contract.label.contractInfo.recipient.contact': '연락처를 작성해주세요',
  'field.contract.label.contractInfo.recipient.businessNumber': '사업자번호를 입력해주세요',
  'field.contract.label.contractInfo.recipient.address': '사업장 주소를 입력해주세요',
  'field.contract.placeholder.contractInfo.recipient.name': '성명을 입력해주세요',
  'field.contract.placeholder.constructionInfo.name': '공사명을 입력해주세요',
  'field.contract.placeholder.contractInfo.contractor.name': '성명을 입력해주세요',
  'field.contract.placeholder.defects.yearsOfLiability': '기간을 입력해주세요',
  'field.contract.placeholder.defects.rateOfRepairDeposit': '비율을 입력해주세요',
  'field.contract.placeholder.defects.rateOfLiquidation': '비율을 입력해주세요',
  'field.contract.placeholder.payment.dueDays1st': 'ex) 공정률 30% 완성 합의 후 2일내',
  'field.contract.placeholder.payment.dueDays2st': 'ex) 공정률 70% 완성 합의 후 2일내',
  'field.contract.placeholder.contractAmount.memoTotal': '(선택) 비고를 작성해주세요',
  'field.contract.placeholder.contractAmount.memoSupply': '(선택) 비고를 작성해주세요',
  'field.contract.placeholder.contractAmount.memoVat': '(선택) 비고를 작성해주세요',
  'field.contract.placeholder.address': '주소지를 입력해주세요',
  'field.contract.placeholder.address2': '상세 주소를 입력해주세요',
  'field.contract.empty.page': '계약서 내용을 꼼꼼하게 확인해주세요',
  'field.contract.contents.placeholder.constructionInfo.name': '#공사명',
  'field.contract.contents.placeholder.constructionInfo.address': '#공사장소',
  'field.contract.contents.placeholder.constructionInfo.dateStart': '#착공일자',
  'field.contract.contents.placeholder.constructionInfo.dateEnd': '#준공일자',
  'field.contract.contents.placeholder.contractAmount.total': '#총공사 금액',
  'field.contract.contents.placeholder.contractAmount.vat': '#부가세',
  'field.contract.contents.placeholder.contractAmount.supply': '#공급가액',
  'field.contract.contents.placeholder.contractAmount.memoTotal': '#비고',
  'field.contract.contents.placeholder.contractAmount.memoSupply': '#비고',
  'field.contract.contents.placeholder.contractAmount.memoVat': '#비고',
  'field.contract.contents.placeholder.payment.advance': '#선급금',
  'field.contract.contents.placeholder.payment.interim1st': '#1차 중도금',
  'field.contract.contents.placeholder.payment.dueDays1st': '#지급조건',
  'field.contract.contents.placeholder.payment.dueDays1st.2': '#지급조건',
  'field.contract.contents.placeholder.payment.interim2st': '#2차 중도금',
  'field.contract.contents.placeholder.payment.dueDays2st': '#지급조건',
  'field.contract.contents.placeholder.payment.dueDays2st.2': '#지급조건',
  'field.contract.contents.placeholder.payment.balance': '#잔금',
  'field.contract.contents.placeholder.defects.yearsOfLiability': '#숫자',
  'field.contract.contents.placeholder.defects.rateOfRepairDeposit': '#숫자',
  'field.contract.contents.placeholder.defects.rateOfLiquidation': '#숫자',
  'field.contract.contents.placeholder.contractInfo.contractor.name': '#도급인 성명',
  'field.contract.contents.placeholder.contractInfo.contractor.contact': '#도급인 연락처',
  'field.contract.contents.placeholder.contractInfo.contractor.address': '#도급인 주소',
  'field.contract.contents.placeholder.contractInfo.recipient.name': '#수급인 성명',
  'field.contract.contents.placeholder.contractInfo.recipient.contact': '#수급인 연락처',
  'field.contract.contents.placeholder.contractInfo.recipient.businessNumber': '#사업자번호',
  'field.contract.contents.placeholder.contractInfo.recipient.address': '#수급인 주소',
  'field.contract.label.specialProvisions': '특약사항을 입력해주세요 (선택)',
  'field.contract.button.specialProvisions': '특약사항 수정하기',
  'field.contract.check.empty.specialProvisions': '특약사항 미작성하기',
  'field.contract.empty.specialProvisions': '특약사항 없음',
  'field.contract.contents.placeholder.specialProvisions': '#특약사항',
  'field.specialProvisions.popup.title': '특약사항',
  'field.contract.fill.form': '양식 채우기',
  'field.contract.new': '새 계약서 작성',
  'field.contract.fileName': '서류명',
  'field.contract.requestDate': '요청일',
  'field.contract.contractDate': '체결일',
  'field.contract.counterpart': '상대방',
  'field.contract.empty.text': '등록된 문서가 없습니다.',
  'field.contract.empty.create': '계약서 새로 생성하기 >',
  'field.contract.label.attachments.sub': '* 10MB 이하 파일만 업로드 가능합니다.',
  'field.contract.label.attachments.1': '1. 산출내역서',
  'field.contract.label.attachments.2': '2. 설계서',
  'common.attachments.file': '파일 첨부',
  'common.attachments.file2': '파일첨부',
  'field.contract.file': '계약 첨부 서류',
  'field.contract.title': '인테리어 공사 도급 계약서',
  'common.cancel.draft': '작성취소',
  'field.contract.request.signature': '계약서 발행하기',
  'field.contract.cancel.popup.title': '저장하지 않은 내용은 사라집니다.\n취소하시겠어요?',
  'moduSign.before.popup.title': '계약서를 발행할까요?',
  'moduSign.before.popup.contents': '계약서를 모두 작성 및 검토하셨나요?\n발행 시 수정이 불가능합니다.',
  'moduSign.before.popup.yes': '네, 발행할게요',
  'moduSign.after.popup.title': '카카오톡으로 전송 완료',
  'moduSign.after.popup.contents': '발행된 계약서를 카카오톡으로 전송했어요\n전자계약서 확인 및 서명을 해주세요',
  'common.go.back': '뒤로가기',
  'field.contract.remindSigning': '서명 요청 재전송하기',
  'contract.status.contract.status.TEMP': '작성중',
  'contract.status.contract.status.ON_PROCESSING': '문서 처리 중',
  'contract.status.contract.status.ON_GOING': '내 서명 필요',
  'contract.status.contract.status.ON_GOING.signed': '상대 서명 대기중',
  'contract.status.contract.status.ABORTED': '계약취소',
  'contract.status.contract.status.COMPLETED': '계약완료',
  'error.constructionInfo.dateEnd': '착공일자 기준 최소 1일 이상 지난 날짜로 선택해주세요',
  'field.contract.example.button': '예시계약서 보기',
  'field.contract.label.attachments.quote': '계약 첨부 서류 2가지를 등록해주세요',

  // field/sales-note
  'field.salesNote': '상담일지',
  'field.salesNote.add': '상담일지 작성',
  'field.salesNote.attachments': '첨부파일 {count}개',
  'field.salesNote.empty.1': '작성된 상담일지가 없습니다.',
  'field.salesNote.empty.2': '상담일지는 직원과 고객에게 공유됩니다',
  'field.salesNote.empty.button': '새 상담일지 작성하기',
  'field.salesNote.add.new': '새 상담일지 작성',
  'field.salesNote.edit': '상담일지 수정',
  'common.photo': '사진',
  'field.salesNote.placeholder': '공간 평형, 가설, 공간 공실 여부, 원하는 스타일 등 시공 공간에 대한 정보를 자유롭게 작성해주세요.',
  'field.salesNote.delete.confirm': '정말 해당 상담일지를\n삭제하시겠어요?',
  'field.salesNote.delete.success': '해당 상담일지를 삭제했습니다',
  'field.salesNote.cancel.edit': '수정 사항을 취소하시겠어요?',
  'field.salesNote.new': '새로 작성하기',
  // only korean
  'field.salesNote.oldData': '고객카드',

  // settings
  'settings.customer.register': '고객연결',
  'settings.customer.register.new': '신규 고객 연결',
  'settings.customer.register.new.input': '고객 신규 연결',
  'settings.customer.register.new.input.placeholder': 'customer@gmail.com',
  'settings.customer.register.new.input.description': '* 현장보고, 상담일지, 채팅방, 서류보관함이 공유됩니다',
  'settings.customer.register.new.button': '초대하기',
  'settings.customer.register.new.invite.success': '{name} 고객님께\n현장 초대를 보냈어요',
  'settings.customer.register.new.invite.success.button': '연결됨',
  'settings.customer.register.new.invite.success.button.waiting': '수락대기',
  'settings.customer.register.new.invite.success.button.reinvite': '재초대 보내기',
  'settings.customer.register.new.invite.success.button.reinvite.success': '{name} 고객님께\n현장 초대를 다시 보냈어요',
  'common.status': '상태',
  'common.waiting.accept': '수락대기',
  'common.connected': '연결됨',
  'err.invited.customer': '이미 초대된 고객입니다',
  'err.recruitment.email.2': '이메일 주소를 정확하게 입력해주세요',

  // setting/me
  'setting.me': '마이페이지',
  'setting.staff': '사내직원관리',
  'setting.staff.title': '사내직원 관리',
  'setting.staff.permission': '권한유무',
  'setting.staff.permission.active': '활성',
  'setting.staff.permission.inactive': '비활성',
  'staff.date.entered': '입사',
  'staff.date.resignation': '퇴사',
  'staff.date.working': '재직중',
  'staff.memo.empty': '메모 없음',
  'setting.staff.detail.title': '직원 상세정보',
  'setting.staff.phone.placeholder': '연락처를 입력해주세요',
  'setting.staff.date.placeholder': '날짜 선택',
  'setting.staff.permission.select': '권한유무 선택',
  'setting.staff.date.entered': '입사일',
  'setting.staff.date.resignation': '퇴사일',
  'setting.staff.memo.placeholder': '메모를 입력해주세요',
  'setting.staff.password.message': '직원 로그인 시, 설정에서\n직접 비밀번호를 수정할 수 있습니다.',
  'setting.staff.create.success': '직원 등록이 완료되었습니다.',
  'setting.staff.create.success.button': '등록완료',
  'setting.staff.modify': '직원정보 수정',
  'dashboard.workLogs.empty.button': '현장보고 작성하기',
  'dashboard.salesNotes.empty.button': '영업노트 작성하기',
  'setting.staff.empty.title': '등록된 직원이 없습니다',
  'setting.staff.empty.button': '사내직원 등록하기 >',

  // private note
  'private.note': '개인노트',
  'private.note.keyword.placeholder': '제목, 내용을 검색해보세요',
  'private.note.create.body.placeholder': '남기고 싶은 개인 메모를 작성해주세요.\n해당 노트는 누구에게도 공유되지 않습니다.',
  'private.note.search.result': '에 해당하는 노트가 없습니다.',
  'private.note.empty': '찾고 계신 노트가 없나요?',
  'private.note.empty.button': '새로 작성하기 >',
  'private.note.empty.title': '제목없음',
  'private.note.empty.body': '내용없음',
  'private.note.empty.attachment': '첨부된 파일이 없습니다',
  'private.note.create.cancel.title': '노트 작성을 취소할까요?',
  'private.note.create.cancel.sub': '작성 취소 시 작성한 내용은\n저장되지 않습니다',
  'private.note.delete.title': '이 노트를 삭제할까요?',
  'private.note.delete.sub': '한 번 삭제하면 다시 복구할 수 없습니다.\n정말 삭제하시겠어요?',
  'private.note.modify.success': '수정 저장되었습니다.',

  // field/account-book
  'field.account.book.staff': '투입직원',
  'field.account.book.open': '펼쳐보기',
  'field.account.book.amount.without.vat': 'VAT 미포함 금액',
  'field.account.book.sales.total': '매출합계(계약금액)',
  'field.account.book.sales.text.1': '이 아직 수금되지 않았습니다\n현재 수금률은',
  'field.account.book.sales.text.2': '입니다',
  'field.account.book.expenses.total.tooltip': '지출총액: 전체지출의 합계\n비율: 전체 매출 대비 지출의 비',
  'field.account.book.expenses.budget.tooltip': '예산총액 대비 지출 초과한 금액의 합계',
  'field.account.book.expenses.remaining': '남은금액',
  'field.account.book.expenses.over.budget': '초과금액',
  'field.account.book.expenses.total.title': '지출총괄',
  'field.account.book.expenses.detail.title': '지출세부',
  'common.etc': '기타',
  'dashboard.field.sales.collections': '매출/수금',
  'field.account.book.progress.payments': '기성관리',
  'field.account.book.progress.payments1': '기성 관리',
  'field.account.book.progress.payments.tooltip': '공식 오픈되기 전 베타버전 기능입니다',
  'field.account.book.progress.payments.total': '미지급액 총합',
  'field.account.book.progress.payments.workType': '공종',
  'field.account.book.progress.payments.contractorName': '업체명',
  'field.account.book.progress.payments.contractAmount': '계약금액',
  'field.account.book.progress.payments.prepaidAmount': '기지급액',
  'field.account.book.progress.payments.unpaidAmount': '미지급액',

  'field.account.book.progress.payments.workType.empty': '도배',
  'field.account.book.progress.payments.contractorName.empty': '(주)씨투와이',
  'dashboard.field.account.book.expense.category.detail': '구분 상세',
  'dashboard.field.account.book.expense.category.detail.empty': '구분 상세를 선택해주세요',
  'dashboard.field.account.book.expense.select.custom': '+ 직접 입력',
  'dashboard.field.account.book.expense.select.custom2': "'로 직접입력",
  'dashboard.field.account.book.expense.select.custom.placeholder': '여기에 직접 입력해주세요',
  'dashboard.field.account.book.expense.select.custom.title': '직접 입력',
  'dashboard.field.account.book.expense.select.search.placeholder': '구분 상세 검색하기',
  'dashboard.field.account.book.empty.profit': '작성된 현장손익이 없습니다',
  'dashboard.field.account.book.empty.profit.button': '현장손익 작성하기 >',
  'dashboard.field.account.book.empty.sales': '작성된 매출/수금이 없습니다.',
  'dashboard.field.account.book.empty.sales.button': '매출/수금 작성하기 >',
  'dashboard.field.account.book.empty.sales.button.text': '매출/수금 작성하기',
  'dashboard.field.account.book.empty.expenses': '작성된 지출이 없습니다.',
  'dashboard.field.account.book.empty.expenses.button': '지출 작성하기 >',
  'dashboard.field.account.book.empty.date': '기간 설정',
  'common.today': '오늘',
  'common.1week': '1주',
  'common.1month': '1개월',
  'common.3month': '3개월',
  'dashboard.tooltip.account.receivable': '매출총액에서 수금총액을\n뺀 금액입니다.',
  'dashboard.field.receivables.total2': '미수금총계',

  // contract
  'contract.label.contractor.name.additional': '* 반드시 실명(성함)으로 작성해주세요.\n   계약서 발행 후 카카오톡으로 전자 서명이 발송됩니다.',

  // field/account-book-ko
  'dashboard.field.expense.date.export': '지출 내역 다운 - 일자별',
  'dashboard.field.expense.category.export': '지출 내역 다운 - 항목별',
  'dashboard.field.export': '출력물로 내보내기',
  'dashboard.field.expense.approval': '지출결의서',
  'dashboard.field.expense.approval.select': '지출 결의서 내역 선택',
  'dashboard.field.expense.approval.empty': '지출 내역을 한 개 이상 선택해주세요.',

  // staff
  'sidebar.material.staff': '직원 관리',
  'staff.list.register': '직원 등록',
  'staff.list.current': '현재 직원',
  'staff.list.restricted': '접속 제한',
  'staff.list.search': '직원 검색',
  'staff.list.filter': '필터',
  'staff.filter.position': '직급',
  'staff.filter.position.input': '직급 입력',
  'staff.filter.date.start': '시작일',
  'staff.filter.date.end': '종료일',
  'staff.filter.date.entered': '입사일',
  'staff.filter.date.resignation': '퇴사일',
  'staff.filter.apply': '적용',
  'staff.filter.close': '닫기',
  'staff.list.department': '조직도',
  'staff.list.department.edit': '편집',
  'staff.list.department.total': '전체',
  'staff.list.department.unassigned': '부서 미배정',
  'staff.create.title': '직원 등록',
  'staff.create.basic.info': '기본 정보',
  'staff.create.basic.info.name': '이름',
  'staff.create.basic.info.name.placeholder': '이름을 입력하세요.',
  'staff.create.basic.info.required.hint': '필수 입력 사항입니다.',
  'staff.create.basic.info.password': '비밀번호',
  'staff.create.basic.info.password.placeholder': '비밀번호를 입력하세요.',
  'staff.create.basic.info.phone': '연락처',
  'staff.create.basic.info.phone.placeholder': '연락처를 입력하세요.',
  'staff.create.basic.info.phone.hint': "'-'없이 숫자만 입력해주세요.",
  'staff.create.basic.info.birthday': '생년월일',
  'staff.create.basic.info.birthday.placeholder': '날짜 선택',
  'staff.create.basic.info.department.title': '조직 내 정보',
  'staff.create.basic.info.department': '부서',
  'staff.create.basic.info.department.empty': '없음',
  'staff.create.basic.info.department.unassigned': '부서 미배정',
  'staff.create.basic.info.position': '직급',
  'staff.create.basic.info.position.placeholder': '직급명을 입력하세요.',
  'staff.create.basic.info.permission': '계정 접속',
  'staff.create.basic.info.permission.allow': '허용',
  'staff.create.basic.info.permission.restrict': '제한',
  'staff.create.basic.info.date.entered': '입사일',
  'staff.create.basic.info.date.entered.placeholder': '입사일을 선택하세요.',
  'staff.create.basic.info.date.resignation': '퇴사일',
  'staff.create.basic.info.date.resignation.placeholder': '퇴사일을 선택하세요.',
  'staff.create.basic.info.profile': '프로필',
  'staff.create.basic.info.profile.upload.placeholder': '첨부할 파일을 여기에 끌어다 놓거나, 업로드 버튼을 통해 직접 선택해주세요',
  'staff.create.basic.info.profile.upload': '파일 업로드',
  'staff.create.basic.info.profile.upload.hint': '5MB 이하의 이미지 파일만 업로드 가능합니다.',
  'staff.create.basic.info.memo': '메모',
  'staff.create.basic.info.memo.placeholder': '메모를 입력하세요.',
  'staff.create.basic.info.memo.hint': '작성한 내용은 직원에게 노출되지 않습니다.',
  'staff.create.basic.info.register': '직원 등록',
  'staff.create.basic.info.cancel': '취소',
  'staff.create.basic.info.warning.title': '구성원 등록을 취소할까요?',
  'staff.create.basic.info.warning.subtitle': '작성한 내용은 저장되지 않습니다.',
  'staff.create.basic.info.warning.confirm': '등록 취소',
  'basic.input.required': ' (필수)',
  'staff.list.empty': '현재 등록된 직원이 없습니다.',
  'staff.list.empty.search': '검색 결과가 없습니다.',
  'staff.list.id': '사번',
  'staff.list.inactive.change': '접속 제한 해제',
  'staff.list.inactive.change.button': '접속 제한 해제',
  'staff.list.inactive.change.success.1': '{name}의 접속 제한을 해제하였습니다.',
  'staff.list.inactive.change.success.2': '{name} 외 {count}명 접속 제한을 해제하였습니다.',
  'staff.list.department.edit.mode': '현재 조직도 편집을 위한 편집 모드 상태입니다.',
  'staff.list.department.delete.title': '부서를 삭제하시겠습니까?',
  'staff.list.department.delete.sub': '해당 부서의 직원은 삭제시 미배정 직원으로 분류됩니다.',
  'staff.list.department.delete': '부서 삭제',
  'staff.list.department.edit.name': '부서명 변경',
  'staff.list.department.create': '새로운 부서',
  'staff.list.edit.mode.exit': '편집 모드 종료',
  'staff.list.department.move': '부서 이동',
  'staff.list.inactive.limit': '접속 제한',
  'staff.list.inactive.limit.title': '선택한 직원을 접속 제한 처리할까요?',
  'staff.list.inactive.limit.sub': '접속 제한 처리된 직원은 로그인할 수 없습니다.',
  'button.move': '이동',
  'staff.list.department.move.input.placeholder': '이동할 부서 선택',
  'staff.list.active.change.success.1': '{name}의 접속을 제한하였습니다.',
  'staff.list.active.change.success.2': '{name} 외 {count}명 접속을 제한하였습니다.',

  'staff.detail.title': '직원 정보',
  'staff.detail.fields': '담당 현장',
  'staff.detail.update.info': '직원 정보 수정',
  'staff.detail.update.password': '비밀번호 변경',
  'staff.detail.update.password.hint': '비밀번호 변경은 구성원 정보 페이지 우측 상단에 있습니다.',
  'staff.modify.success': '저장 완료되었습니다.',
  'staff.modify.title': '정보 수정',
  'staff.detail.update.password.placeholder': '변경할 비밀번호를 입력하세요.',
  'button.modify.password': '변경',
  'staff.detail.update.password.success': '비밀번호를 변경하였습니다.',

  'staff.detail.info.body.memo.title': '직원 메모',
  'staff.detail.info.body.memo.button.collapse': '접기',
  'staff.detail.info.body.memo.button.expand': '펼치기',
  'staff.detail.info.body.contents.title': '기본 정보',
  'staff.detail.info.body.department.title': '조직 내 정보',
  'staff.detail.info.body.permission.allow': '허용',
  'staff.detail.info.body.permission.restrict': '접속 제한',
  'staff.detail.info.body.work.title': '근무 이력',
  'staff.detail.info.body.work.period': '재직 기간',
  'staff.detail.info.body.work.entered': '입사일',
  'staff.detail.info.body.work.resigned': '퇴사일',
  'staff.detail.field.search': '현장명 검색',
  'staff.detail.field.ledger.sales': '매출액',
  'staff.detail.field.ledger.profit': '현재 수익',
  'staff.detail.field.ledger.receivable': '미수금 총액',
  'staff.detail.field.construct.status.WORKING': '시공진행중',
  'staff.detail.field.construct.status.DUMMY': '수주 보류',
  'staff.detail.field.construct.status.CONSULTING': '상담중',
  'staff.detail.field.construct.status.COMPLETE': '시공 완료',
  'staff.detail.field.footer.staff': '담당직원',
  'staff.detail.field.footer.profit': '현장손익',
  'staff.detail.field.empty': '담당 현장이 없습니다.',
  'staff.role': '권한',
  'staff.role.MEMBER': '직원',
  'staff.role.SUPERVISOR': '관리자',

  'common.won': '원',
  'staff.detail.field.empty.permission1': '관련 권한이 없습니다.',
  'staff.detail.field.empty.permission2': '사내 담당자에게 문의해주세요.',

  'staff.update.popup.header.select': '선택 직원',
  'staff.update.popup.header.all': '전체',
  'staff.update.popup.header.restricted': '접속 제한 직원 보기',
  'staff.update.popup.header.leave.title': '현장을 나가시겠습니까?',
  'staff.update.popup.header.leave.confirm': '나가기',

  'field.add.update.empty.title': '먼저 현장을 등록해주세요',
  'field.add.update.empty.sub': '새 현장 등록 후 이용가능합니다.\n바로 현장을 생성하시겠어요?',
  'field.add.update.empty.button': '현장 등록하기',

  'customer.support.chat.header': '나야 채팅',
  'customer.support.chat.input.placeholder': '메시지를 입력해주세요',
  'customer.support.chat.input.button': '보내기',
  'customer.support.chat.default.message': '나야 고객센터',

  'staff.list.search.result.1': '에 대한 검색 결과',
  'staff.list.search.result.2': '총',
  'staff.list.search.result.3': '명',

  'staff.list.filter.all': '적용 필터 {count}',
  'customer.support.chat.input.file.size': '파일은 200MB까지 첨부할 수 있습니다.',

  'upload.business.registration.view.title': '사업자등록증 (필수)',
  'upload.business.registration.view.upload.text': '파일 업로드',
  'upload.business.registration.view.hint': '용량이 10mb 이상인 파일은 업로드가 제한됩니다.',

  'order.shopping.cart': '장바구니',
  'order.confirm': '자재 발주서',
  'order.complete': '발주 요청 완료',
  'order.search.placeholder': '자재명 입력',
  'order.type.BASIC': '전체상품',
  'order.type.BUDGET': '내현장자재',
  'order.type.FAVORITE': '즐겨찾기',
  'order.search.result': '‘에 대한 검색 결과입니다.',
  'order.divider.button.text': '나야채팅',
  'order.divider.text.1': '보이는 가격보다 저렴하게 발주하고 싶다면?',
  'order.divider.text.2': '견적서만 있으면 빠르게 자재 세팅해드려요!',
  'order.divider.text.3': '어떤 업무든 OK! 나야 상담원과 직접 소통하세요',
  'common.all': '전체',

  'material.area.header.all.title': '총',
  'material.area.header.all.count': '개',
  'material.area.header.all.product': '상품',

  'material.area.empty.title': '검색된 자재가 없습니다.',
  'material.area.empty.sub': '다른 검색어를 사용하시거나 나야 채팅으로 문의해주세요',
  'material.area.empty.favorite.title': '현재 즐겨찾기에 등록된 자재가 없습니다.',
  'material.area.empty.favorite.sub': '우리 회사가 자주 구매하는 자재를 즐겨찾기에 등록해보세요.',

  'material.area.budget.empty.label': '자재 세팅',
  'material.area.budget.empty.title': '현장에 사용될 자재 리스트를\n보내주시면 이곳에 세팅됩니다.',
  'material.area.budget.empty.subtitle': '사용하실 자재 리스트를 엑셀, 화면 캡처 이미지 등 형식에 관계없이\n보내주시기만 하면 바로 구매하실 수 있게 이곳에 세팅해드려요.',
  'material.area.budget.empty.button': '자재 리스트 보내기',
  'material.estimate': '특별할인',

  'material.budget.notice': '내현장자재는 보내주신 견적서를 기반으로 생성된 자재 목록입니다.',
  'material.favorite.notice': '즐겨찾기의 자재 목록은 모든 직원이 공유합니다.',

  'footer.company.name': '(주)씨투와이(C2Y)',
  'footer.company.representative': '대표이사 : 문준철',
  'footer.company.business.number': '사업자등록번호 : 896-81-01068',
  'footer.company.communication.number': '통신판매업신고번호 : 제2025-서울마포-2127호',
  'footer.company.address': '주소 : 서울시 마포구 330. 318호 (상암동, 디엠씨첨단산업센터)',
  'footer.company.email': '이메일 문의 : info@nayac2y.com',
  'footer.company.time': '운영시간 : 08:30 ~ 18:00',
  'footer.company.phone': '전화문의 : 1644-4908',
  'footer.company.copyright': 'Copyright',
  'footer.company.copyright.text': '© ️C2Y.',
  'footer.company.all.rights.reserved': 'All Rights Reserved',
  'footer.company.phone.text': '문의 1644-4908',
  'footer.company.time.text': '오전 08시 30분 ~ 오후 05시 30분',
  'footer.company.time.text.2': '주말 및 공휴일은 휴무입니다',
  'order.addToCart.description': '발주 요청에 따라 배송비가 책정됩니다.',
  'order.addToCart.title': '자재 담기',
  'order.addToCart.checkLists.title': '필수 옵션',
  'order.addToCart.quantity.title': '자재 수량',
  'order.addToCart.footer.button': '장바구니 담기',
  'order.addToCart.footer.text': '옵션을 선택 및 입력해주세요',
  'order.addToCart.close': '나가기',
  'order.addToCart.stay': '마저 담기',
  'order.addToCart.popup.title': '잠깐! 상품을 아직 담지 않았습니다.',
  'order.addToCart.popup.sub': '이대로 담지 않고 나갈까요?',
  'order.addToCart.success': '장바구니에 상품을 담았습니다.',

  'order.detail.tab.info': '상품 상세 정보',
  'order.detail.tab.return': '반품 / 교환 정보',
  'order.detail.notice': '발주 요청에 맞추어 배송비가 책정됩니다.',
  'order.detail.notice.title': '상품 공지 사항',
  'order.detail.total.price': '총 상품 금액',
  'order.detail.quantity': '총 수량',
  'order.detail.notice.text': '알려드립니다',
  'order.detail.notice.text.1': '원활한 발주를 위해',
  'order.detail.notice.text.2': '구매는 상품을 담은 후 장바구니',
  'order.detail.notice.text.3': '에서 가능합니다.',

  'order.detail.info.tab.title': '상품 상세 정보',
  'order.detail.info.tab.origin': '원산지',
  'order.detail.info.tab.brand': '브랜드명',
  'order.detail.info.tab.thickness': '두께',
  'order.detail.info.tab.color': '컬러',
  'order.detail.info.tab.standard': '규격',
  'order.detail.info.tab.modelNumber': '모델품번',
  'order.detail.info.tab.type': '타입',
  'order.detail.info.tab.flameRetardant': '방염여부',
  'order.detail.info.tab.pcsBox': 'PCS/BOX',
  'order.detail.info.tab.certification': '인증서 유무',
  'order.detail.info.tab.m2Box': 'M2/BOX',
  'order.detail.info.tab.part': '부속폼 정보',
  'order.detail.info.tab.luminosity': '광도',
  'order.detail.info.tab.rawMaterial': '소재',
  'order.detail.info.tab.applicationArea': '적용부위',
  'order.detail.info.tab.information': '종합설명',

  'order.detail.checkList.required': '{name}은(는) 필수입력 항목입니다.\n옵션을 입력해주세요.',

  'order.detail.return.tab.title': '반품 / 교환\n요청 가능 기간',
  'order.detail.return.tab.subtitle.1': '단순 변심으로 인한 교환 / 반품 건에 한하여 수령 후 7일 이내 가능합니다.',
  'order.detail.return.tab.subtitle.2': '반품 / 교환\n불가 사유',
  'order.detail.return.tab.subtitle.3': '1. 요청기간이 지난 경우\n2. 소비자 귀책으로 상품이 멸실 또는 훼손된 경우\n3. 소비자 사용 또는 일부 소비로 상품 가치가 현저히 감소한 경우\n4. ',
  'order.detail.return.tab.subtitle.4': '고객 요청 사항에 맞춰 제작되는 맞춤 제작 상품의 경우',
  'order.detail.return.tab.subtitle.5': '\n· 제작 착수 후 청약철회 및 환불, 취소가 불가합니다.\n5. 그 외 관련 법령에 따라 청약철회가 제한되는 경우',

  'order.shopping.cart.material': '담은 자재',

  'order.shopping.cart.delete': '선택 삭제',
  'order.shopping.cart.select.all': '전체 선택',
  'order.shopping.cart.product': '상품',
  'order.shopping.cart.quantity.and.option': '수량 및 옵션',
  'order.shopping.cart.product.quantity': '상품 수량',
  'order.shopping.cart.modify': '주문 수정',
  'order.shopping.cart.discount': '특별 할인',

  'order.shopping.cart.remaining.quantity': '남은 수량',
  'order.shopping.cart.remaining.quantity.excess': '{count}개 초과',

  'order.shopping.cart.payment.title': '결제 예정금액',
  'common.vat': '부가세',
  'order.shopping.cart.delivery.fee': '배송비 (VAT포함)',
  'order.shopping.cart.delivery.fee.separate': '별도 청구',
  'order.shopping.cart.final.price': '최종금액',
  'order.shopping.cart.payment.notice.title': '결제 안내',
  'order.shopping.cart.payment.notice': '발주 요청 후 자재 공급처에서 재고 확인 및 배송비를 책정하면 결제할 수 있습니다.',
  'order.shopping.cart.order.request': '자재 발주',
  'order.shopping.cart.quantity': '{count}건',
  'order.shopping.cart.quantity.excess.popup.title': '예산 초과된 상품이 있습니다.',
  'order.shopping.cart.product.price': '상품금액',
  'order.confirm.delivery.info.title': '배송 정보',
  'order.confirm.delivery.info.address.title': '배송지 정보',
  'order.confirm.inspector.info.title': '인수자 정보',
  'order.confirm.desired.inspection.time.title': '희망 인수 일시',
  'order.confirm.order.request.memo.title': '주문 요청사항 (선택)',
  'order.confirm.order.request.memo.placeholder': '주문 요청사항을 입력하세요.',
  'order.confirm.inspector.name.title': '인수자',
  'order.confirm.inspector.name.placeholder': '인수자명을 입력하세요.',
  'order.confirm.inspector.phone.title': '휴대폰',
  'order.confirm.inspector.phone.placeholder': '연락처 번호를 입력하세요.',
  'order.confirm.inspector.date.title': '인수일',
  'order.confirm.inspector.date.placeholder': '인수일을 선택하세요.',
  'order.confirm.inspector.time.title': '인수 시간',

  'order.shopping.cart.delete.popup.title': '상품을 장바구니에서 삭제할까요?',
  'order.confirm.remove.from.order.popup.title': '상품을 주문 상품에서 삭제할까요?',

  'order.complete.title': '발주 요청 완료',
  'order.complete.subtitle': '발주서가 접수되었습니다.\n재고 및 배송비가 확인되면 결제 요청 알림을 보내드립니다.',
  'order.complete.button': '자재주문 홈으로',
  'order.complete.time.title': '이용시간 안내',
  'order.complete.time.subtitle': '평일 08:30~17:30 / 토요일 : 08:30~10:30 / 공휴일 휴무',
  'order.complete.time.subtitle.2': '시간 외 주문하신 내용은 업무일 오전에 확인 후 처리됩니다.',
  'order.complete.select.material': '자재를 선택해주세요',
  'order.complete.field.name': '{fieldName}현장',
  'order.complete.field.change': '현장 변경',
  'order.complete.inspector.fill.current.user': '현재 로그인 정보로 채우기',
  'order.complete.field.name.title': '현장명',
  'order.complete.field.name.placeholder': '현장명을 입력해주세요(최대 15자)',
  'order.complete.field.address.title': '주소',
  'order.complete.field.address.placeholder': '주소지를 입력해주세요',
  'order.complete.field.address2.title': '상세 주소',
  'order.complete.field.address2.placeholder': '상세 주소를 입력해주세요',
  'order.complete.field.select.title': '현장 선택',
  'order.complete.field.select.button': '+ 새 현장 생성하기',

  'order.confirm.date.required.delivery.before.now': '희망 인수 일시를 확인해주세요',

  'customer.support.chat.button.alarm.text': '😄 답변이 도착했어요',
  'customer.support.chat.header.active.time': '몇분 이내로 답변 받으실 수 있어요',
  'customer.support.chat.header.inactive.time': '현재는 운영 시간이 아닙니다.',
  'common.end': '종료',

  'customer.support.chat.auto.reply.button.text': '모바일에서 확인해주세요',
  'customer.support.chat.notice.phone': '문의 전화 1644-4908',
  'customer.support.chat.notice.time': '월~금 08:30~17:30 (주말, 공휴일 제외)',

  'customer.support.chat.faq.title': '자주 묻는 질문',

  'customer.support.chat.daily.alarm.text.1': '자재 발주부터 사업 지원 서비스, ERP 사용 문의까지',
  'customer.support.chat.daily.alarm.text.2': '나야 상담원과 직접 소통하여 빠르게 해결하세요!',

  'material.area.empty.image.title': '이 상품들은 가격 정책으로\n현재 노출되지 않고 있습니다.',
  'material.area.empty.image.subtitle': '찾고 계신 자재를 아래로 요청해주시면\n귀사를 위한 단가로 견적서를 보내드려요',
  'material.area.empty.image.button': '견적단가 요청하기',

  'order.main.body.search.area.empty.title': '찾으시는 상품은 가격 정책으로 노출되지 않는 상품일 수 있습니다.',
  'order.main.body.search.area.empty.subtitle': '나야 채팅으로 요청해주시면 최적의 단가로 구성된 견적서를 보내드립니다!',
  'order.main.body.search.area.empty.button': '나야 채팅으로 요청하기',

  'order.main.body.promotion.title': '프로모션',
  'sidebar.field.setting': '현장설정',
  'customer.support.chat.title': '나야채팅',
  'order.main.body.promotion.link': 'https://www.nayac2y.com/event/?q=YToxOntzOjEyOiJrZXl3b3JkX3R5cGUiO3M6MzoiYWxsIjt9&bmode=view&idx=168501829&t=board',

  'order.detail.empty': '해당 상품이 존재하지 않습니다.',

  'order.shopping.cart.quantity.excess.popup.sub': '관리자에게 해당 자재 예산을\n추가 요청할까요?',

  'order.budget.request.complete': '요청 완료',
  'order.budget.request.memo.required': '필수 입력입니다.',

  // 견적/시장가 라벨
  'material.specialDiscount': '특별할인',
  'material.eventPrice': '이벤트특가',

  'material.area.associated.image.title': '본 카테고리는 NICE 협회 회원사\n전용 특가 상품입니다.',
  'material.area.associated.image.subtitle': '아래 버튼을 눌러 협회 가입 후\n회원사 전용 특가 자재를 확인해보세요.',
  'material.area.associated.image.button': '협회 가입하기',
};
